/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "+n/P":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f2ff2475c2d156465fa3c19ff0b8a574.svg";

/***/ }),

/***/ "/QC5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Link = exports.Route = exports.Router = exports.route = exports.getCurrentUrl = exports.subscribers = undefined;

var _preact = __webpack_require__("KM04");

var EMPTY$1 = {};

function assign(obj, props) {
	// eslint-disable-next-line guard-for-in
	for (var i in props) {
		obj[i] = props[i];
	}
	return obj;
}

function exec(url, route, opts) {
	var reg = /(?:\?([^#]*))?(#.*)?$/,
	    c = url.match(reg),
	    matches = {},
	    ret;
	if (c && c[1]) {
		var p = c[1].split('&');
		for (var i = 0; i < p.length; i++) {
			var r = p[i].split('=');
			matches[decodeURIComponent(r[0])] = decodeURIComponent(r.slice(1).join('='));
		}
	}
	url = segmentize(url.replace(reg, ''));
	route = segmentize(route || '');
	var max = Math.max(url.length, route.length);
	for (var i$1 = 0; i$1 < max; i$1++) {
		if (route[i$1] && route[i$1].charAt(0) === ':') {
			var param = route[i$1].replace(/(^\:|[+*?]+$)/g, ''),
			    flags = (route[i$1].match(/[+*?]+$/) || EMPTY$1)[0] || '',
			    plus = ~flags.indexOf('+'),
			    star = ~flags.indexOf('*'),
			    val = url[i$1] || '';
			if (!val && !star && (flags.indexOf('?') < 0 || plus)) {
				ret = false;
				break;
			}
			matches[param] = decodeURIComponent(val);
			if (plus || star) {
				matches[param] = url.slice(i$1).map(decodeURIComponent).join('/');
				break;
			}
		} else if (route[i$1] !== url[i$1]) {
			ret = false;
			break;
		}
	}
	if (opts.default !== true && ret === false) {
		return false;
	}
	return matches;
}

function pathRankSort(a, b) {
	return a.rank < b.rank ? 1 : a.rank > b.rank ? -1 : a.index - b.index;
}

// filter out VNodes without attributes (which are unrankeable), and add `index`/`rank` properties to be used in sorting.
function prepareVNodeForRanking(vnode, index) {
	vnode.index = index;
	vnode.rank = rankChild(vnode);
	return vnode.attributes;
}

function segmentize(url) {
	return url.replace(/(^\/+|\/+$)/g, '').split('/');
}

function rankSegment(segment) {
	return segment.charAt(0) == ':' ? 1 + '*+?'.indexOf(segment.charAt(segment.length - 1)) || 4 : 5;
}

function rank(path) {
	return segmentize(path).map(rankSegment).join('');
}

function rankChild(vnode) {
	return vnode.attributes.default ? 0 : rank(vnode.attributes.path);
}

var customHistory = null;

var ROUTERS = [];

var subscribers = [];

var EMPTY = {};

function isPreactElement(node) {
	return node.__preactattr_ != null || typeof Symbol !== 'undefined' && node[Symbol.for('preactattr')] != null;
}

function setUrl(url, type) {
	if (type === void 0) type = 'push';

	if (customHistory && customHistory[type]) {
		customHistory[type](url);
	} else if (typeof history !== 'undefined' && history[type + 'State']) {
		history[type + 'State'](null, null, url);
	}
}

function getCurrentUrl() {
	var url;
	if (customHistory && customHistory.location) {
		url = customHistory.location;
	} else if (customHistory && customHistory.getCurrentLocation) {
		url = customHistory.getCurrentLocation();
	} else {
		url = typeof location !== 'undefined' ? location : EMPTY;
	}
	return "" + (url.pathname || '') + (url.search || '');
}

function route(url, replace) {
	if (replace === void 0) replace = false;

	if (typeof url !== 'string' && url.url) {
		replace = url.replace;
		url = url.url;
	}

	// only push URL into history if we can handle it
	if (canRoute(url)) {
		setUrl(url, replace ? 'replace' : 'push');
	}

	return routeTo(url);
}

/** Check if the given URL can be handled by any router instances. */
function canRoute(url) {
	for (var i = ROUTERS.length; i--;) {
		if (ROUTERS[i].canRoute(url)) {
			return true;
		}
	}
	return false;
}

/** Tell all router instances to handle the given URL.  */
function routeTo(url) {
	var didRoute = false;
	for (var i = 0; i < ROUTERS.length; i++) {
		if (ROUTERS[i].routeTo(url) === true) {
			didRoute = true;
		}
	}
	for (var i$1 = subscribers.length; i$1--;) {
		subscribers[i$1](url);
	}
	return didRoute;
}

function routeFromLink(node) {
	// only valid elements
	if (!node || !node.getAttribute) {
		return;
	}

	var href = node.getAttribute('href'),
	    target = node.getAttribute('target');

	// ignore links with targets and non-path URLs
	if (!href || !href.match(/^\//g) || target && !target.match(/^_?self$/i)) {
		return;
	}

	// attempt to route, if no match simply cede control to browser
	return route(href);
}

function handleLinkClick(e) {
	if (e.button == 0) {
		routeFromLink(e.currentTarget || e.target || this);
		return prevent(e);
	}
}

function prevent(e) {
	if (e) {
		if (e.stopImmediatePropagation) {
			e.stopImmediatePropagation();
		}
		if (e.stopPropagation) {
			e.stopPropagation();
		}
		e.preventDefault();
	}
	return false;
}

function delegateLinkHandler(e) {
	// ignore events the browser takes care of already:
	if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) {
		return;
	}

	var t = e.target;
	do {
		if (String(t.nodeName).toUpperCase() === 'A' && t.getAttribute('href') && isPreactElement(t)) {
			if (t.hasAttribute('native')) {
				return;
			}
			// if link is handled by the router, prevent browser defaults
			if (routeFromLink(t)) {
				return prevent(e);
			}
		}
	} while (t = t.parentNode);
}

var eventListenersInitialized = false;

function initEventListeners() {
	if (eventListenersInitialized) {
		return;
	}

	if (typeof addEventListener === 'function') {
		if (!customHistory) {
			addEventListener('popstate', function () {
				routeTo(getCurrentUrl());
			});
		}
		addEventListener('click', delegateLinkHandler);
	}
	eventListenersInitialized = true;
}

var Router = function (Component$$1) {
	function Router(props) {
		Component$$1.call(this, props);
		if (props.history) {
			customHistory = props.history;
		}

		this.state = {
			url: props.url || getCurrentUrl()
		};

		initEventListeners();
	}

	if (Component$$1) Router.__proto__ = Component$$1;
	Router.prototype = Object.create(Component$$1 && Component$$1.prototype);
	Router.prototype.constructor = Router;

	Router.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
		if (props.static !== true) {
			return true;
		}
		return props.url !== this.props.url || props.onChange !== this.props.onChange;
	};

	/** Check if the given URL can be matched against any children */
	Router.prototype.canRoute = function canRoute(url) {
		return this.getMatchingChildren(this.props.children, url, false).length > 0;
	};

	/** Re-render children with a new URL to match against. */
	Router.prototype.routeTo = function routeTo(url) {
		this._didRoute = false;
		this.setState({ url: url });

		// if we're in the middle of an update, don't synchronously re-route.
		if (this.updating) {
			return this.canRoute(url);
		}

		this.forceUpdate();
		return this._didRoute;
	};

	Router.prototype.componentWillMount = function componentWillMount() {
		ROUTERS.push(this);
		this.updating = true;
	};

	Router.prototype.componentDidMount = function componentDidMount() {
		var this$1 = this;

		if (customHistory) {
			this.unlisten = customHistory.listen(function (location) {
				this$1.routeTo("" + (location.pathname || '') + (location.search || ''));
			});
		}
		this.updating = false;
	};

	Router.prototype.componentWillUnmount = function componentWillUnmount() {
		if (typeof this.unlisten === 'function') {
			this.unlisten();
		}
		ROUTERS.splice(ROUTERS.indexOf(this), 1);
	};

	Router.prototype.componentWillUpdate = function componentWillUpdate() {
		this.updating = true;
	};

	Router.prototype.componentDidUpdate = function componentDidUpdate() {
		this.updating = false;
	};

	Router.prototype.getMatchingChildren = function getMatchingChildren(children, url, invoke) {
		return children.filter(prepareVNodeForRanking).sort(pathRankSort).map(function (vnode) {
			var matches = exec(url, vnode.attributes.path, vnode.attributes);
			if (matches) {
				if (invoke !== false) {
					var newProps = { url: url, matches: matches };
					assign(newProps, matches);
					delete newProps.ref;
					delete newProps.key;
					return (0, _preact.cloneElement)(vnode, newProps);
				}
				return vnode;
			}
		}).filter(Boolean);
	};

	Router.prototype.render = function render(ref, ref$1) {
		var children = ref.children;
		var onChange = ref.onChange;
		var url = ref$1.url;

		var active = this.getMatchingChildren(children, url, true);

		var current = active[0] || null;
		this._didRoute = !!current;

		var previous = this.previousUrl;
		if (url !== previous) {
			this.previousUrl = url;
			if (typeof onChange === 'function') {
				onChange({
					router: this,
					url: url,
					previous: previous,
					active: active,
					current: current
				});
			}
		}

		return current;
	};

	return Router;
}(_preact.Component);

var Link = function Link(props) {
	return (0, _preact.h)('a', assign({ onClick: handleLinkClick }, props));
};

var Route = function Route(props) {
	return (0, _preact.h)(props.component, props);
};

Router.subscribers = subscribers;
Router.getCurrentUrl = getCurrentUrl;
Router.route = route;
Router.Router = Router;
Router.Route = Route;
Router.Link = Link;

exports.subscribers = subscribers;
exports.getCurrentUrl = getCurrentUrl;
exports.route = route;
exports.Router = Router;
exports.Route = Route;
exports.Link = Link;
exports.default = Router;
//# sourceMappingURL=preact-router.es.js.map

/***/ }),

/***/ "1yJE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (e, t) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = t() :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.ReactPixel = t() : e.ReactPixel = t();
}(undefined, function () {
  return function (e) {
    function t(r) {
      if (n[r]) return n[r].exports;var o = n[r] = { i: r, l: !1, exports: {} };return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }var n = {};return t.m = e, t.c = n, t.i = function (e) {
      return e;
    }, t.d = function (e, n, r) {
      t.o(e, n) || Object.defineProperty(e, n, { configurable: !1, enumerable: !0, get: r });
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };return t.d(n, "a", n), n;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 1);
  }([function (e, t, n) {
    "use strict";
    function r(e) {
      if (Array.isArray(e)) {
        for (var t = 0, n = Array(e.length); t < e.length; t++) {
          n[t] = e[t];
        }return n;
      }return Array.from(e);
    }Object.defineProperty(t, "__esModule", { value: !0 });var o = !1,
        i = !1,
        a = function a() {
      return o || console.warn("Pixel not initialized before using call ReactPixel.init with required params"), o;
    },
        c = function c() {
      for (var e, t = arguments.length, n = Array(t), o = 0; o < t; o++) {
        n[o] = arguments[o];
      }(e = console).info.apply(e, r(["[react-facebook-pixel]"].concat(n)));
    },
        f = { autoConfig: !0, debug: !1 };t.default = { init: function init(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : f;!function (e, t, n, r, o, i, a) {
          e.fbq || (o = e.fbq = function () {
            o.callMethod ? o.callMethod.apply(o, arguments) : o.queue.push(arguments);
          }, e._fbq || (e._fbq = o), o.push = o, o.loaded = !0, o.version = "2.0", o.queue = [], i = t.createElement(n), i.async = !0, i.src = r, a = t.getElementsByTagName(n)[0], a.parentNode.insertBefore(i, a));
        }(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js"), e ? (!1 === n.autoConfig && fbq("set", "autoConfig", !1, e), fbq("init", e, t), o = !0, i = n.debug) : console.warn("Please insert pixel id for initializing");
      }, pageView: function pageView() {
        a() && (fbq("track", "PageView"), i && c("called fbq('track', 'PageView');"));
      }, track: function track(e, t) {
        a() && (fbq("track", e, t), i && (c("called fbq('track', '" + e + "');"), t && c("with data", t)));
      }, trackCustom: function trackCustom(e, t) {
        a() && (fbq("trackCustom", e, t), i && (c("called fbq('trackCustom', '" + e + "');"), t && c("with data", t)));
      }, fbq: function (e) {
        function t() {
          return e.apply(this, arguments);
        }return t.toString = function () {
          return e.toString();
        }, t;
      }(function () {
        if (a()) {
          for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) {
            t[n] = arguments[n];
          }fbq.apply(void 0, t), i && (c("called fbq('" + t.slice(0, 2).join("', '") + "')"), t[2] && c("with data", t[2]));
        }
      }) };
  }, function (e, t, n) {
    e.exports = n(0);
  }]);
});
//# sourceMappingURL=fb-pixel.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("l262")(module)))

/***/ }),

/***/ "26FX":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./account-circle.svg": "Q+Lj",
	"./chevron-down.svg": "BSdL",
	"./chevron-left.svg": "7RId",
	"./chevron-right.svg": "9OQQ",
	"./chevron-up.svg": "NlGM",
	"./close.svg": "xofd",
	"./exclamation.svg": "LpZc",
	"./home.svg": "s2D/",
	"./info.svg": "TV5B",
	"./keg.svg": "S35x",
	"./loader.svg": "YoSI",
	"./logout.svg": "TYkI",
	"./menu.svg": "+n/P",
	"./minus.svg": "J1Ic",
	"./pencil.svg": "AefZ",
	"./pint.svg": "gvtp",
	"./plus.svg": "kv8w",
	"./tick.svg": "GnHr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "26FX";

/***/ }),

/***/ "2AfE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("KM04");

var _classnames = __webpack_require__("9qb7");

var _classnames2 = _interopRequireDefault(_classnames);

var _content = __webpack_require__("SFgq");

var _content2 = _interopRequireDefault(_content);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Content = function (_Component) {
	_inherits(Content, _Component);

	function Content() {
		_classCallCheck(this, Content);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Content.prototype.render = function render(_ref) {
		var children = _ref.children,
		    className = _ref.className;

		var classes = (0, _classnames2.default)(_content2.default.container, className);
		return (0, _preact.h)(
			'section',
			{ className: classes },
			children
		);
	};

	return Content;
}(_preact.Component);

exports.default = Content;

/***/ }),

/***/ "3zBa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _class, _temp;

var _preact = __webpack_require__("KM04");

var _classnames = __webpack_require__("9qb7");

var _classnames2 = _interopRequireDefault(_classnames);

var _icon = __webpack_require__("L46F");

var _icon2 = _interopRequireDefault(_icon);

var _inlineMessage = __webpack_require__("bdl5");

var _inlineMessage2 = _interopRequireDefault(_inlineMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var glyphs = {
  error: 'exclamation',
  info: 'info',
  success: 'tick'
};

var InlineMessage = (_temp = _class = function (_Component) {
  _inherits(InlineMessage, _Component);

  function InlineMessage() {
    _classCallCheck(this, InlineMessage);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  InlineMessage.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        type = _props.type;

    return (0, _preact.h)(
      'div',
      { className: (0, _classnames2.default)('flex', _inlineMessage2.default.container, _inlineMessage2.default[type]) },
      (0, _preact.h)(_icon2.default, { glyph: glyphs[type], className: _inlineMessage2.default.icon }),
      (0, _preact.h)(
        'span',
        { className: (0, _classnames2.default)(_inlineMessage2.default.message, 'flex-grow') },
        children
      )
    );
  };

  return InlineMessage;
}(_preact.Component), _class.defaultProps = {
  type: 'info'
}, _temp);
exports.default = InlineMessage;

/***/ }),

/***/ "5D9O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("wVGV")();
}

/***/ }),

/***/ "5JYR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("KM04");

var _border = __webpack_require__("nZ5c");

var _border2 = _interopRequireDefault(_border);

var _footer = __webpack_require__("KlFx");

var _footer2 = _interopRequireDefault(_footer);

var _content = __webpack_require__("2AfE");

var _content2 = _interopRequireDefault(_content);

var _trade = __webpack_require__("o15H");

var _trade2 = _interopRequireDefault(_trade);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Privacy = function (_Component) {
  _inherits(Privacy, _Component);

  function Privacy() {
    _classCallCheck(this, Privacy);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Privacy.prototype.render = function render() {
    return (0, _preact.h)(
      'div',
      null,
      (0, _preact.h)(
        'div',
        { className: _trade2.default.container },
        (0, _preact.h)(
          _content2.default,
          null,
          (0, _preact.h)(
            'div',
            { className: _trade2.default.text },
            (0, _preact.h)(
              'div',
              { className: 'flex' },
              (0, _preact.h)(
                'a',
                { href: '/' },
                (0, _preact.h)('img', { className: _trade2.default.logo, src: '/assets/logo-red.png', alt: 'Trouble Brewing' })
              ),
              (0, _preact.h)(
                'h1',
                { className: _trade2.default.title },
                'Privacy Policy'
              )
            ),
            (0, _preact.h)(
              'p',
              null,
              'Last updated: ',
              (0, _preact.h)(
                'strong',
                null,
                '30th January 2017'
              )
            ),
            (0, _preact.h)(
              'p',
              null,
              'Trouble Brewing ("us", "we", or "our") operates www.troublebrewing.com (the "Site"). This page informs you of our policies regarding the collection, use and disclosure of Personal Information we receive from users of the Site.'
            ),
            (0, _preact.h)(
              'p',
              null,
              'We use your Personal Information only for providing and improving the Site. By using the Site, you agree to the collection and use of information in accordance with this policy.'
            ),
            (0, _preact.h)(
              'h2',
              null,
              'Information Collection and Use'
            ),
            (0, _preact.h)(
              'p',
              null,
              'While using our Site, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to your name, address, payment and email details. We\u2019ll only use the personal information for the purpose that it was collected for, or if it is essential to our services. Typical situations where your consent will be implied include, but are not limited to disclosure to third parties that provide services such as our payment gateway, marketing, logistic and technology support. These elements are considered essential to conducting a transaction.'
            ),
            (0, _preact.h)(
              'p',
              null,
              'Where you\u2019ve given consent, we may use your Personal Information to contact you with newsletters, marketing or promotional materials and other information. '
            ),
            (0, _preact.h)(
              'h2',
              null,
              'Log Data'
            ),
            (0, _preact.h)(
              'p',
              null,
              'Like many site operators, we collect information that your browser sends whenever you visit our Site ("Log Data").'
            ),
            (0, _preact.h)(
              'p',
              null,
              'This Log Data may include information such as your computer\'s Internet Protocol ("IP") address, browser type, browser version, the pages of our Site that you visit, the time and date of your visit, the time spent on those pages and other statistics.'
            ),
            (0, _preact.h)(
              'p',
              null,
              'In addition, we may use third party services such as Google Analytics or Lucep that collect, monitor and analyse data. '
            ),
            (0, _preact.h)(
              'h2',
              null,
              'Cookies'
            ),
            (0, _preact.h)(
              'p',
              null,
              'Cookies are files with small amount of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and stored on your computer\'s hard drive.'
            ),
            (0, _preact.h)(
              'p',
              null,
              'Like many sites, we use "cookies" to collect information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Site.'
            ),
            (0, _preact.h)(
              'h2',
              null,
              'Security'
            ),
            (0, _preact.h)(
              'p',
              null,
              'The security of your Personal Information is important to us, but remember that no method of transmission over the Internet, or method of electronic storage, is 100% secure. While we strive to use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security. '
            ),
            (0, _preact.h)(
              'p',
              null,
              'We do not store credit card details on our servers, all credit card transactions are processed using our secure payment gateway Stripe.'
            ),
            (0, _preact.h)(
              'h2',
              null,
              'Changes to This Privacy Policy'
            ),
            (0, _preact.h)(
              'p',
              null,
              'This Privacy Policy is effective as of 30th January 2018 and will remain in effect except with respect to any changes in its provisions in the future, which will be in effect immediately after being posted on this page.'
            ),
            (0, _preact.h)(
              'p',
              null,
              'We reserve the right to update or change our Privacy Policy at any time and you should check this Privacy Policy periodically. Your continued use of the Service after we post any modifications to the Privacy Policy on this page will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified Privacy Policy.'
            ),
            (0, _preact.h)(
              'p',
              null,
              'If we make any material changes to this Privacy Policy, we will notify you either through the email address you have provided us, or by placing a prominent notice on our website.'
            ),
            (0, _preact.h)(
              'h2',
              null,
              'Contact Us'
            ),
            (0, _preact.h)(
              'p',
              null,
              'If you have any questions about this Privacy Policy, please contact us at ',
              (0, _preact.h)(
                'a',
                { href: 'mailto:hello@troublebrewing.com' },
                'hello@troublebrewing.com'
              ),
              '.'
            )
          )
        ),
        (0, _preact.h)(_border2.default, { color: 'black' })
      ),
      (0, _preact.h)(_footer2.default, null)
    );
  };

  return Privacy;
}(_preact.Component);

exports.default = Privacy;

/***/ }),

/***/ "7RId":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c2657b3311102f69736300fdf30dc89f.svg";

/***/ }),

/***/ "7Wgl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"button__7lCAZ","disabled":"disabled__1EGEU","primary":"primary__iRrTX","secondary":"secondary__A0YxJ","tertiary":"tertiary__xBKfY"};

/***/ }),

/***/ "9OQQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b0d81596a3e7194c4484a63f9f5a293c.svg";

/***/ }),

/***/ "9dvf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__2Y9IN","text":"text__3xR0o","title":"title__yVJan","subTitle":"subTitle__2fJ_j"};

/***/ }),

/***/ "9qb7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if ("function" === 'function' && _typeof(__webpack_require__("yNJ0")) === 'object' && __webpack_require__("yNJ0")) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),

/***/ "Aa1G":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("KM04");

var _icon = __webpack_require__("L46F");

var _icon2 = _interopRequireDefault(_icon);

var _header = __webpack_require__("HLoY");

var _header2 = _interopRequireDefault(_header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = function (_Component) {
  _inherits(Header, _Component);

  function Header() {
    var _temp, _this, _ret;

    _classCallCheck(this, Header);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      open: false
    }, _this.close = function () {
      _this.setState({
        open: false
      });
    }, _this.toggleOpen = function () {
      _this.setState({
        open: !_this.state.open
      });
    }, _this.renderItems = function () {
      if (_this.props.homeOnly) {
        return (0, _preact.h)(
          'ul',
          { className: _header2.default.menu },
          (0, _preact.h)(
            'li',
            { className: _header2.default.menuItem },
            (0, _preact.h)(
              'a',
              { href: '/', className: _header2.default.menuLink, onClick: _this.close },
              'Home'
            )
          )
        );
      }

      return (0, _preact.h)(
        'ul',
        { className: _header2.default.menu },
        (0, _preact.h)(
          'li',
          { className: _header2.default.menuItem },
          (0, _preact.h)(
            'a',
            { href: '#page-about', className: _header2.default.menuLink, onClick: _this.close },
            'About Us'
          )
        ),
        (0, _preact.h)(
          'li',
          { className: _header2.default.menuItem },
          (0, _preact.h)(
            'a',
            { href: '#page-products', className: _header2.default.menuLink, onClick: _this.close },
            'Products'
          )
        ),
        (0, _preact.h)(
          'li',
          { className: _header2.default.menuItem },
          (0, _preact.h)(
            'a',
            { href: '#page-contact', className: _header2.default.menuLink, onClick: _this.close },
            'Contact'
          )
        ),
        (0, _preact.h)(
          'li',
          { className: _header2.default.menuItem + ' ' + _header2.default.socialItem },
          (0, _preact.h)(
            'a',
            { href: 'https://www.facebook.com/TroubleBrewingSingapore/', target: '_blank', rel: 'noopener noreferrer' },
            (0, _preact.h)('img', { className: _header2.default.social, src: '/assets/facebookCircle.png' })
          )
        ),
        (0, _preact.h)(
          'li',
          { className: _header2.default.menuItem + ' ' + _header2.default.socialItem },
          (0, _preact.h)(
            'a',
            { href: 'https://www.instagram.com/troublebrewingsg/', target: '_blank', rel: 'noopener noreferrer' },
            (0, _preact.h)('img', { className: _header2.default.social, src: '/assets/instagramCircle.png' })
          )
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Header.prototype.render = function render() {
    var open = this.state.open;


    return (0, _preact.h)(
      'header',
      { className: _header2.default.container },
      (0, _preact.h)(
        'div',
        { className: _header2.default.inner },
        (0, _preact.h)(
          'div',
          { className: _header2.default.title },
          (0, _preact.h)(
            'h1',
            null,
            'Trouble Brewing'
          ),
          (0, _preact.h)(
            'a',
            { href: '/' },
            (0, _preact.h)('img', { className: _header2.default.logo, src: '/assets/logo.png', alt: 'Trouble Brewing' })
          )
        ),
        (0, _preact.h)(
          'button',
          { className: 'clearButton ' + _header2.default.openNav, onClick: this.toggleOpen },
          (0, _preact.h)(_icon2.default, { glyph: 'menu' })
        ),
        open && (0, _preact.h)('div', { className: _header2.default.overlay, onClick: this.close }),
        (0, _preact.h)(
          'nav',
          { className: _header2.default.navigation + ' ' + (open ? _header2.default.navigationOpen : '') },
          (0, _preact.h)(
            'button',
            { className: 'clearButton ' + _header2.default.closeNav, onClick: this.toggleOpen },
            (0, _preact.h)(_icon2.default, { glyph: 'close' })
          ),
          this.renderItems()
        )
      )
    );
  };

  return Header;
}(_preact.Component);

exports.default = Header;

/***/ }),

/***/ "AefZ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0835fcd83b9d19e221438f7fc3908fad.svg";

/***/ }),

/***/ "Asjh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ "BSdL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4e7122c6239c5d84bf50273e0f7f147c.svg";

/***/ }),

/***/ "BXnN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("KM04");

var _border = __webpack_require__("nZ5c");

var _border2 = _interopRequireDefault(_border);

var _content = __webpack_require__("2AfE");

var _content2 = _interopRequireDefault(_content);

var _products = __webpack_require__("OzB/");

var _products2 = _interopRequireDefault(_products);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Products = function (_Component) {
  _inherits(Products, _Component);

  function Products() {
    var _temp, _this, _ret;

    _classCallCheck(this, Products);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      hoverSubscription: false,
      hoverOneOff: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Products.prototype.renderSubscription = function renderSubscription() {
    var _this2 = this;

    var hoverSubscription = this.state.hoverSubscription;

    var image = hoverSubscription ? '/assets/subscription-hover.png' : '/assets/subscription.png';
    return (0, _preact.h)(
      'div',
      null,
      (0, _preact.h)('img', { src: '/assets/text-go-with.png', className: _products2.default.goWithText }),
      (0, _preact.h)(
        'a',
        { href: '#page-subscription' },
        (0, _preact.h)('img', { className: _products2.default.subscription,
          src: image,
          onMouseEnter: function onMouseEnter() {
            return _this2.setState({ hoverSubscription: true });
          },
          onMouseLeave: function onMouseLeave() {
            return _this2.setState({ hoverSubscription: false });
          } })
      )
    );
  };

  Products.prototype.renderOneOff = function renderOneOff() {
    var _this3 = this;

    var hoverOneOff = this.state.hoverOneOff;

    var image = hoverOneOff ? '/assets/oneoff-hover.png' : '/assets/oneoff.png';

    return (0, _preact.h)(
      'div',
      null,
      (0, _preact.h)('img', { src: '/assets/text-or-this.png', className: _products2.default.orText }),
      (0, _preact.h)(
        'a',
        { href: '#page-one-off' },
        (0, _preact.h)('img', { className: _products2.default.oneOff,
          src: image,
          onMouseEnter: function onMouseEnter() {
            return _this3.setState({ hoverOneOff: true });
          },
          onMouseLeave: function onMouseLeave() {
            return _this3.setState({ hoverOneOff: false });
          } })
      )
    );
  };

  Products.prototype.render = function render() {
    return (0, _preact.h)(
      'div',
      { className: _products2.default.container, id: 'page-products' },
      (0, _preact.h)(
        _content2.default,
        null,
        (0, _preact.h)(
          'div',
          { className: 'flex ' + _products2.default.content },
          (0, _preact.h)(
            'div',
            { className: 'flex ' + _products2.default.productContainer },
            this.renderSubscription(),
            this.renderOneOff()
          ),
          (0, _preact.h)(
            'div',
            null,
            (0, _preact.h)(
              'h2',
              { className: _products2.default.title },
              'Our products'
            ),
            (0, _preact.h)(
              'h3',
              { className: _products2.default.subTitle },
              'What we provide'
            ),
            (0, _preact.h)(
              'p',
              null,
              'Whether it\u2019s providing a portable bar and kegs for your office, or producing cases of branded beer bottles for a memorable event, we\u2019ve got you covered.'
            ),
            (0, _preact.h)(
              'p',
              null,
              'Our wide range of beers and flavours ensure we\u2019ve got something for everyone. And because we brew right here in Singapore, we\u2019re able to get it to you quickly.'
            )
          )
        )
      ),
      (0, _preact.h)(_border2.default, { color: 'white' })
    );
  };

  return Products;
}(_preact.Component);

exports.default = Products;

/***/ }),

/***/ "FRX4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("KM04");

var _hero = __webpack_require__("dwPy");

var _hero2 = _interopRequireDefault(_hero);

var _about = __webpack_require__("h1h4");

var _about2 = _interopRequireDefault(_about);

var _products = __webpack_require__("BXnN");

var _products2 = _interopRequireDefault(_products);

var _contact = __webpack_require__("q4w7");

var _contact2 = _interopRequireDefault(_contact);

var _footer = __webpack_require__("KlFx");

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Home = function (_Component) {
  _inherits(Home, _Component);

  function Home() {
    _classCallCheck(this, Home);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Home.prototype.render = function render() {
    return (0, _preact.h)(
      'div',
      null,
      (0, _preact.h)(_hero2.default, null),
      (0, _preact.h)(_about2.default, null),
      (0, _preact.h)(_products2.default, null),
      (0, _preact.h)(_contact2.default, null),
      (0, _preact.h)(_footer2.default, null)
    );
  };

  return Home;
}(_preact.Component);

exports.default = Home;

/***/ }),

/***/ "FgT3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"loader":"loader__1INrZ","spin":"spin__18z5h"};

/***/ }),

/***/ "GnHr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4f280347f69e51cd656ad0a665f38306.svg";

/***/ }),

/***/ "HLoY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__ENwRt","inner":"inner__2ssQd","title":"title__2NyXZ","logo":"logo__2A4EQ","menu":"menu__2nvJG","menuItem":"menuItem__2UXZm","menuLink":"menuLink__q_fdr","openNav":"openNav__1ALLX","closeNav":"closeNav__1OHqH","overlay":"overlay__2qi-S","navigation":"navigation__2vdRe","navigationOpen":"navigationOpen__19D1L","socialItem":"socialItem__1JttZ","social":"social__2zRry"};

/***/ }),

/***/ "HZyB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__2N0ju","textContainer":"textContainer__1QbtX","contactFormContainer":"contactFormContainer__3C9lN","helloText":"helloText__2matt","callUsText":"callUsText__3hL6p","content":"content__vKtgG"};

/***/ }),

/***/ "Hw2k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__1uYiT","inner":"inner__6AyDX","nav":"nav__2_Va3","copyright":"copyright__1bDpy","navItem":"navItem__1E_fk","social":"social__1bYuF"};

/***/ }),

/***/ "J1Ic":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1312b493fd802f86fa63899cc77fd072.svg";

/***/ }),

/***/ "JkW7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _app = __webpack_require__("qLaj");

var _app2 = _interopRequireDefault(_app);

var _reactGa = __webpack_require__("Z70r");

var _reactGa2 = _interopRequireDefault(_reactGa);

var _reactFacebookPixel = __webpack_require__("1yJE");

var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);

var _config = __webpack_require__("MmR0");

var _config2 = _interopRequireDefault(_config);

__webpack_require__("Q3aS");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_reactFacebookPixel2.default.init(_config2.default.facebook.pixelId);
_reactGa2.default.initialize(_config2.default.googleAnalytics.trackingId);

exports.default = _app2.default;

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function () {
  "use strict";
  function e() {}function t(t, n) {
    var o,
        r,
        i,
        l,
        a = E;for (l = arguments.length; l-- > 2;) {
      W.push(arguments[l]);
    }n && null != n.children && (W.length || W.push(n.children), delete n.children);while (W.length) {
      if ((r = W.pop()) && void 0 !== r.pop) for (l = r.length; l--;) {
        W.push(r[l]);
      } else "boolean" == typeof r && (r = null), (i = "function" != typeof t) && (null == r ? r = "" : "number" == typeof r ? r += "" : "string" != typeof r && (i = !1)), i && o ? a[a.length - 1] += r : a === E ? a = [r] : a.push(r), o = i;
    }var u = new e();return u.nodeName = t, u.children = a, u.attributes = null == n ? void 0 : n, u.key = null == n ? void 0 : n.key, void 0 !== S.vnode && S.vnode(u), u;
  }function n(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function o(e, o) {
    return t(e.nodeName, n(n({}, e.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : e.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == A.push(e) && (S.debounceRendering || P)(i);
  }function i() {
    var e,
        t = A;A = [];while (e = t.pop()) {
      e.__d && k(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var t = n({}, e.attributes);t.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === t[r] && (t[r] = o[r]);
    }return t;
  }function _(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function c(e, t, n, o, r) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n && n(null), o && o(e);else if ("class" !== t || r) {
      if ("style" === t) {
        if (o && "string" != typeof o && "string" != typeof n || (e.style.cssText = o || ""), o && "object" == (typeof o === "undefined" ? "undefined" : _typeof(o))) {
          if ("string" != typeof n) for (var i in n) {
            i in o || (e.style[i] = "");
          }for (var i in o) {
            e.style[i] = "number" == typeof o[i] && !1 === V.test(i) ? o[i] + "px" : o[i];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) o && (e.innerHTML = o.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var l = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), o ? n || e.addEventListener(t, f, l) : e.removeEventListener(t, f, l), (e.__l || (e.__l = {}))[t] = o;
      } else if ("list" !== t && "type" !== t && !r && t in e) s(e, t, null == o ? "" : o), null != o && !1 !== o || e.removeAttribute(t);else {
        var a = r && t !== (t = t.replace(/^xlink:?/, ""));null == o || !1 === o ? a ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof o && (a ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), o) : e.setAttribute(t, o));
      }
    } else e.className = o || "";
  }function s(e, t, n) {
    try {
      e[t] = n;
    } catch (e) {}
  }function f(e) {
    return this.__l[e.type](S.event && S.event(e) || e);
  }function d() {
    var e;while (e = D.pop()) {
      S.afterMount && S.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function h(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, j = null != e && !("__preactattr_" in e));var l = m(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (j = !1, i || d()), l;
  }function m(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return U(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = _(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0);
    }var p = i.firstChild,
        c = i.__preactattr_,
        s = t.children;if (null == c) {
      c = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        c[f[d].name] = f[d].value;
      }
    }return !j && s && 1 === s.length && "string" == typeof s[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != s[0] && (p.nodeValue = s[0]) : (s && s.length || null != p) && v(i, s, n, o, j || null != c.dangerouslySetInnerHTML), g(i, t.attributes, c), R = l, i;
  }function v(e, t, n, o, r) {
    var i,
        a,
        u,
        _,
        c,
        s = e.childNodes,
        f = [],
        d = {},
        h = 0,
        v = 0,
        y = s.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = s[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (h++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      _ = t[C], c = null;var k = _.key;if (null != k) h && void 0 !== d[k] && (c = d[k], d[k] = void 0, h--);else if (!c && v < g) for (i = v; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], _, r)) {
          c = a, f[i] = void 0, i === g - 1 && g--, i === v && v++;break;
        }
      }c = m(c, _, n, o), u = s[C], c && c !== e && c !== u && (null == u ? e.appendChild(c) : c === u.nextSibling ? p(u) : e.insertBefore(c, u));
    }if (h) for (var C in d) {
      void 0 !== d[C] && b(d[C], !1);
    }while (v <= g) {
      void 0 !== (c = f[g--]) && b(c, !1);
    }
  }function b(e, t) {
    var n = e._component;n ? L(n) : (null != e.__preactattr_ && e.__preactattr_.ref && e.__preactattr_.ref(null), !1 !== t && null != e.__preactattr_ || p(e), y(e));
  }function y(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;b(e, !0), e = t;
    }
  }function g(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || c(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || c(e, o, n[o], n[o] = t[o], R);
    }
  }function w(e) {
    var t = e.constructor.name;(I[t] || (I[t] = [])).push(e);
  }function C(e, t, n) {
    var o,
        r = I[e.name];if (e.prototype && e.prototype.render ? (o = new e(t, n), T.call(o, t, n)) : (o = new T(t, n), o.constructor = e, o.render = x), r) for (var i = r.length; i--;) {
      if (r[i].constructor === e) {
        o.__b = r[i].__b, r.splice(i, 1);break;
      }
    }return o;
  }function x(e, t, n) {
    return this.constructor(e, n);
  }function N(e, t, n, o, i) {
    e.__x || (e.__x = !0, (e.__r = t.ref) && delete t.ref, (e.__k = t.key) && delete t.key, !e.base || i ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, o), o && o !== e.context && (e.__c || (e.__c = e.context), e.context = o), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== n && (1 !== n && !1 === S.syncComponentUpdates && e.base ? r(e) : k(e, 1, i)), e.__r && e.__r(e));
  }function k(e, t, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          _ = e.props,
          p = e.state,
          c = e.context,
          s = e.__p || _,
          f = e.__s || p,
          m = e.__c || c,
          v = e.base,
          y = e.__b,
          g = v || y,
          w = e._component,
          x = !1;if (v && (e.props = s, e.state = f, e.context = m, 2 !== t && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(_, p, c) ? x = !0 : e.componentWillUpdate && e.componentWillUpdate(_, p, c), e.props = _, e.state = p, e.context = c), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !x) {
        i = e.render(_, p, c), e.getChildContext && (c = n(n({}, c), e.getChildContext()));var U,
            T,
            M = i && i.nodeName;if ("function" == typeof M) {
          var W = u(i);l = w, l && l.constructor === M && W.key == l.__k ? N(l, W, 1, c, !1) : (U = l, e._component = l = C(M, W, c), l.__b = l.__b || y, l.__u = e, N(l, W, 0, c, !1), k(l, 1, o, !0)), T = l.base;
        } else a = g, U = w, U && (a = e._component = null), (g || 1 === t) && (a && (a._component = null), T = h(a, i, c, o || !v, g && g.parentNode, !0));if (g && T !== g && l !== w) {
          var E = g.parentNode;E && T !== E && (E.replaceChild(T, g), U || (g._component = null, b(g, !1)));
        }if (U && L(U), e.base = T, T && !r) {
          var P = e,
              V = e;while (V = V.__u) {
            (P = V).base = T;
          }T._component = P, T._componentConstructor = P.constructor;
        }
      }if (!v || o ? D.unshift(e) : x || (e.componentDidUpdate && e.componentDidUpdate(s, f, m), S.afterUpdate && S.afterUpdate(e)), null != e.__h) while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || d();
    }
  }function U(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        _ = a,
        p = u(t);while (r && !_ && (r = r.__u)) {
      _ = r.constructor === t.nodeName;
    }return r && _ && (!o || r._component) ? (N(r, p, 3, n, o), e = r.base) : (i && !a && (L(i), e = l = null), r = C(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), N(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, b(l, !1))), e;
  }function L(e) {
    S.beforeUnmount && S.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var n = e._component;n ? L(n) : t && (t.__preactattr_ && t.__preactattr_.ref && t.__preactattr_.ref(null), e.__b = t, p(t), w(e), y(t)), e.__r && e.__r(null);
  }function T(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {};
  }function M(e, t, n) {
    return h(n, e, {}, !1, t, !1);
  }var S = {},
      W = [],
      E = [],
      P = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      V = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      A = [],
      D = [],
      H = 0,
      R = !1,
      j = !1,
      I = {};n(T.prototype, { setState: function setState(e, t) {
      var o = this.state;this.__s || (this.__s = n({}, o)), n(o, "function" == typeof e ? e(o, this.props) : e), t && (this.__h = this.__h || []).push(t), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && (this.__h = this.__h || []).push(e), k(this, 2);
    }, render: function render() {} });var $ = { h: t, createElement: t, cloneElement: o, Component: T, render: M, rerender: i, options: S }; true ? module.exports = $ : self.preact = $;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "KgDl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("KM04");

var _classnames = __webpack_require__("9qb7");

var _classnames2 = _interopRequireDefault(_classnames);

var _icon = __webpack_require__("L46F");

var _icon2 = _interopRequireDefault(_icon);

var _loader = __webpack_require__("FgT3");

var _loader2 = _interopRequireDefault(_loader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _default = function (_Component) {
  _inherits(_default, _Component);

  function _default() {
    _classCallCheck(this, _default);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  _default.prototype.render = function render() {
    var className = this.props.className;


    return (0, _preact.h)(_icon2.default, { glyph: 'loader', className: (0, _classnames2.default)(_loader2.default.loader, className) });
  };

  return _default;
}(_preact.Component);

exports.default = _default;

/***/ }),

/***/ "KlFx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("KM04");

var _classnames = __webpack_require__("9qb7");

var _classnames2 = _interopRequireDefault(_classnames);

var _preactRouter = __webpack_require__("/QC5");

var _content = __webpack_require__("2AfE");

var _content2 = _interopRequireDefault(_content);

var _footer = __webpack_require__("Hw2k");

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Footer = function (_Component) {
  _inherits(Footer, _Component);

  function Footer() {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Footer.prototype.render = function render() {
    var className = this.props.className;

    return (0, _preact.h)(
      'footer',
      { className: (0, _classnames2.default)(className, _footer2.default.container) },
      (0, _preact.h)(
        _content2.default,
        null,
        (0, _preact.h)(
          'div',
          { className: 'flex' },
          (0, _preact.h)(
            'nav',
            { className: _footer2.default.nav },
            (0, _preact.h)(
              'span',
              { className: (0, _classnames2.default)(_footer2.default.copyright, 'flex-grow') },
              '\xA9 Trouble Brewing ',
              new Date().getFullYear()
            ),
            (0, _preact.h)(
              _preactRouter.Link,
              { className: _footer2.default.navItem, href: '/privacy' },
              'Privacy Policy'
            ),
            (0, _preact.h)(
              _preactRouter.Link,
              { className: _footer2.default.navItem, href: '/terms' },
              'Ts & Cs'
            ),
            (0, _preact.h)(
              'span',
              { className: _footer2.default.menuItem + ' ' + _footer2.default.sociaspantem },
              (0, _preact.h)(
                'a',
                { href: 'https://www.facebook.com/TroubleBrewingSingapore/', target: '_blank', rel: 'noopener noreferrer' },
                (0, _preact.h)('img', { className: _footer2.default.social, src: '/assets/facebookCircle.png' })
              )
            ),
            (0, _preact.h)(
              'span',
              { className: _footer2.default.menuItem + ' ' + _footer2.default.socialItem },
              (0, _preact.h)(
                'a',
                { href: 'https://www.instagram.com/troublebrewingsg/', target: '_blank', rel: 'noopener noreferrer' },
                (0, _preact.h)('img', { className: _footer2.default.social, src: '/assets/instagramCircle.png' })
              )
            )
          )
        )
      )
    );
  };

  return Footer;
}(_preact.Component);

exports.default = Footer;

/***/ }),

/***/ "L46F":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("KM04");

var _classnames = __webpack_require__("9qb7");

var _classnames2 = _interopRequireDefault(_classnames);

var _icon = __webpack_require__("mw+q");

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Import references to all files in the `./svg` directory, but only if we're not in test
var glyphs = {};
var req = __webpack_require__("26FX");
req.keys().forEach(function (key) {
  glyphs[key.replace('./', '').replace('.svg', '')] = req(key);
});

var Icon = function Icon(_ref) {
  var glyph = _ref.glyph,
      size = _ref.size,
      className = _ref.className,
      onClick = _ref.onClick;
  return (0, _preact.h)(
    'svg',
    { onClick: onClick, className: (0, _classnames2.default)(_icon2.default.icon, className), width: size, height: size },
    (0, _preact.h)('use', { xlinkHref: glyphs[glyph].default })
  );
};

Icon.defaultProps = {
  size: 24
};

exports.default = Icon;

/***/ }),

/***/ "LpZc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "715466db0b320a77af82839f5ebdc7d5.svg";

/***/ }),

/***/ "MmR0":
/***/ (function(module, exports) {

module.exports = {"googleAnalytics":{"trackingId":"UA-106125679-1"},"firebase":{"cloudFunctionUrl":"https://us-central1-trouble-brewing-staging.cloudfunctions.net"},"campaign":{"url":"https://campaign.dev.troublebrewing.com"},"facebook":{"pixelId":"1234"}}

/***/ }),

/***/ "NlGM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9f95a4c5e8a3d410057142d58bba7f37.svg";

/***/ }),

/***/ "OzB/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__eroVz","text":"text__2zNNy","title":"title__3yTxh","subTitle":"subTitle__2TPZ-","productContainer":"productContainer__1DbeM","product":"product__13bTP","productTitle":"productTitle__gqcnZ","productDescription":"productDescription__2LxB9","subscription":"subscription__15dqw","oneOff":"oneOff__2SxMw","goWithText":"goWithText__2EGIk","orText":"orText__Xxmaf","content":"content__1QKXS"};

/***/ }),

/***/ "Q+Lj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2d20f904d7f82e2b8843231529b1a7ce.svg";

/***/ }),

/***/ "Q3aS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R8GG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"errorList":"errorList__3xgIW"};

/***/ }),

/***/ "S35x":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e395f4204b3e8045f4443b03931475cf.svg";

/***/ }),

/***/ "SFgq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__330y8"};

/***/ }),

/***/ "TV5B":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7bf1db7fc2aaa49db6820e1c605b9d0d.svg";

/***/ }),

/***/ "TYkI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d7d4027504452f62d2ef4297f7828627.svg";

/***/ }),

/***/ "UQex":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),

/***/ "Y6Xg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"border":"border__kapPa","white":"white__3DUkp","black":"black__3EVBP","red":"red__3Da0C"};

/***/ }),

/***/ "YoSI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ee8670f033296c2568f42b61b2f2db2f.svg";

/***/ }),

/***/ "Z70r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function webpackUniversalModuleDefinition(root, factory) {
  if (( false ? 'undefined' : _typeof2(exports)) === 'object' && ( false ? 'undefined' : _typeof2(module)) === 'object') module.exports = factory(__webpack_require__("eW0v"), __webpack_require__("5D9O"));else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("eW0v"), __webpack_require__("5D9O")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else {
    var a = (typeof exports === 'undefined' ? 'undefined' : _typeof2(exports)) === 'object' ? factory(require("react"), require("prop-types")) : factory(root["react"], root["prop-types"]);
    for (var i in a) {
      ((typeof exports === 'undefined' ? 'undefined' : _typeof2(exports)) === 'object' ? exports : root)[i] = a[i];
    }
  }
})(typeof self !== 'undefined' ? self : undefined, function (__WEBPACK_EXTERNAL_MODULE_11__, __WEBPACK_EXTERNAL_MODULE_12__) {
  return (/******/function (modules) {
      // webpackBootstrap
      /******/ // The module cache
      /******/var installedModules = {};
      /******/
      /******/ // The require function
      /******/function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
          /******/return installedModules[moduleId].exports;
          /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/var module = installedModules[moduleId] = {
          /******/i: moduleId,
          /******/l: false,
          /******/exports: {}
          /******/ };
        /******/
        /******/ // Execute the module function
        /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/return module.exports;
        /******/
      }
      /******/
      /******/
      /******/ // expose the modules object (__webpack_modules__)
      /******/__webpack_require__.m = modules;
      /******/
      /******/ // expose the module cache
      /******/__webpack_require__.c = installedModules;
      /******/
      /******/ // define getter function for harmony exports
      /******/__webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
          /******/Object.defineProperty(exports, name, {
            /******/configurable: false,
            /******/enumerable: true,
            /******/get: getter
            /******/ });
          /******/
        }
        /******/
      };
      /******/
      /******/ // getDefaultExport function for compatibility with non-harmony modules
      /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ?
        /******/function getDefault() {
          return module['default'];
        } :
        /******/function getModuleExports() {
          return module;
        };
        /******/__webpack_require__.d(getter, 'a', getter);
        /******/return getter;
        /******/
      };
      /******/
      /******/ // Object.prototype.hasOwnProperty.call
      /******/__webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/
      /******/ // __webpack_public_path__
      /******/__webpack_require__.p = "";
      /******/
      /******/ // Load entry module and return exports
      /******/return __webpack_require__(__webpack_require__.s = 2);
      /******/
    }(
    /************************************************************************/
    /******/[
    /* 0 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = warn;
      function warn(s) {
        console.warn('[react-ga]', s);
      }

      /***/
    },
    /* 1 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = trim;
      // GA strings need to have leading/trailing whitespace trimmed, and not all
      // browsers have String.prototoype.trim().

      function trim(s) {
        return s.replace(/^\s+|\s+$/g, '');
      }

      /***/
    },
    /* 2 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.testModeAPI = exports.OutboundLink = exports.plugin = undefined;

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }return target;
      };

      var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
        return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      };

      exports.initialize = initialize;
      exports.ga = ga;
      exports.set = set;
      exports.send = send;
      exports.pageview = pageview;
      exports.modalview = modalview;
      exports.timing = timing;
      exports.event = event;
      exports.exception = exception;
      exports.outboundLink = outboundLink;

      var _format2 = __webpack_require__(3);

      var _format3 = _interopRequireDefault(_format2);

      var _removeLeadingSlash = __webpack_require__(6);

      var _removeLeadingSlash2 = _interopRequireDefault(_removeLeadingSlash);

      var _trim = __webpack_require__(1);

      var _trim2 = _interopRequireDefault(_trim);

      var _loadGA = __webpack_require__(7);

      var _loadGA2 = _interopRequireDefault(_loadGA);

      var _warn = __webpack_require__(0);

      var _warn2 = _interopRequireDefault(_warn);

      var _log = __webpack_require__(8);

      var _log2 = _interopRequireDefault(_log);

      var _testModeAPI = __webpack_require__(9);

      var _testModeAPI2 = _interopRequireDefault(_testModeAPI);

      var _OutboundLink = __webpack_require__(10);

      var _OutboundLink2 = _interopRequireDefault(_OutboundLink);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _objectWithoutProperties(obj, keys) {
        var target = {};for (var i in obj) {
          if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
        }return target;
      }

      function _toConsumableArray(arr) {
        if (Array.isArray(arr)) {
          for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
          }return arr2;
        } else {
          return Array.from(arr);
        }
      } /**
         * React Google Analytics Module
         *
         * @package react-ga
         * @author  Adam Lofting <adam@mozillafoundation.org>
         *          Atul Varma <atul@mozillafoundation.org>
         */

      /**
       * Utilities
       */

      var _debug = false;
      var _titleCase = true;
      var _testMode = false;
      var _alwaysSendToDefaultTracker = true;

      var internalGa = function internalGa() {
        var _window;

        if (_testMode) return _testModeAPI2.default.ga.apply(_testModeAPI2.default, arguments);
        if (!window.ga) return (0, _warn2.default)('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
        return (_window = window).ga.apply(_window, arguments);
      };

      function _format(s) {
        return (0, _format3.default)(s, _titleCase);
      }

      function _gaCommand(trackerNames) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        var command = args[0];
        if (typeof internalGa === 'function') {
          if (typeof command !== 'string') {
            (0, _warn2.default)('ga command must be a string');
            return;
          }

          if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(undefined, args);
          if (Array.isArray(trackerNames)) {
            trackerNames.forEach(function (name) {
              internalGa.apply(undefined, _toConsumableArray([name + '.' + command].concat(args.slice(1))));
            });
          }
        }
      }

      function _initialize(gaTrackingID, options) {
        if (!gaTrackingID) {
          (0, _warn2.default)('gaTrackingID is required in initialize()');
          return;
        }

        if (options) {
          if (options.debug && options.debug === true) {
            _debug = true;
          }

          if (options.titleCase === false) {
            _titleCase = false;
          }
        }

        if (options && options.gaOptions) {
          internalGa('create', gaTrackingID, options.gaOptions);
        } else {
          internalGa('create', gaTrackingID, 'auto');
        }
      }

      function initialize(configsOrTrackingId, options) {
        if (options && options.testMode === true) {
          _testMode = true;
        } else {
          if (typeof window === 'undefined') {
            return false;
          }

          (0, _loadGA2.default)(options);
        }

        _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;

        if (Array.isArray(configsOrTrackingId)) {
          configsOrTrackingId.forEach(function (config) {
            if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) !== 'object') {
              (0, _warn2.default)('All configs must be an object');
              return;
            }
            _initialize(config.trackingId, config);
          });
        } else {
          _initialize(configsOrTrackingId, options);
        }
        return true;
      }

      /**
       * ga:
       * Returns the original GA object.
       */
      function ga() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        if (args.length > 0) {
          internalGa.apply(undefined, args);
          if (_debug) {
            (0, _log2.default)('called ga(\'arguments\');');
            (0, _log2.default)('with arguments: ' + JSON.stringify(args));
          }
        }

        return window.ga;
      }

      /**
       * set:
       * GA tracker set method
       * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
       * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
       */
      function set(fieldsObject, trackerNames) {
        if (!fieldsObject) {
          (0, _warn2.default)('`fieldsObject` is required in .set()');
          return;
        }

        if ((typeof fieldsObject === 'undefined' ? 'undefined' : _typeof(fieldsObject)) !== 'object') {
          (0, _warn2.default)('Expected `fieldsObject` arg to be an Object');
          return;
        }

        if (Object.keys(fieldsObject).length === 0) {
          (0, _warn2.default)('empty `fieldsObject` given to .set()');
        }

        _gaCommand(trackerNames, 'set', fieldsObject);

        if (_debug) {
          (0, _log2.default)('called ga(\'set\', fieldsObject);');
          (0, _log2.default)('with fieldsObject: ' + JSON.stringify(fieldsObject));
        }
      }

      /**
       * send:
       * Clone of the low level `ga.send` method
       * WARNING: No validations will be applied to this
       * @param  {Object} fieldObject - field object for tracking different analytics
       * @param  {Array} trackerNames - trackers to send the command to
       * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
       */
      function send(fieldObject, trackerNames) {
        _gaCommand(trackerNames, 'send', fieldObject);
        if (_debug) {
          (0, _log2.default)('called ga(\'send\', fieldObject);');
          (0, _log2.default)('with fieldObject: ' + JSON.stringify(fieldObject));
          (0, _log2.default)('with trackers: ' + JSON.stringify(trackerNames));
        }
      }

      /**
       * pageview:
       * Basic GA pageview tracking
       * @param  {String} path - the current page page e.g. '/about'
       * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
       * @param {String} title - (optional) the page title e. g. 'My Website'
       */
      function pageview(rawPath, trackerNames, title) {
        if (!rawPath) {
          (0, _warn2.default)('path is required in .pageview()');
          return;
        }

        var path = (0, _trim2.default)(rawPath);
        if (path === '') {
          (0, _warn2.default)('path cannot be an empty string in .pageview()');
          return;
        }

        var extraFields = {};
        if (title) {
          extraFields.title = title;
        }

        if (typeof ga === 'function') {
          _gaCommand(trackerNames, 'send', _extends({
            hitType: 'pageview',
            page: path
          }, extraFields));

          if (_debug) {
            (0, _log2.default)('called ga(\'send\', \'pageview\', path);');
            var extraLog = '';
            if (title) {
              extraLog = ' and title: ' + title;
            }
            (0, _log2.default)('with path: ' + path + extraLog);
          }
        }
      }

      /**
       * modalview:
       * a proxy to basic GA pageview tracking to consistently track
       * modal views that are an equivalent UX to a traditional pageview
       * @param  {String} modalName e.g. 'add-or-edit-club'
       * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
       */
      function modalview(rawModalName, trackerNames) {
        if (!rawModalName) {
          (0, _warn2.default)('modalName is required in .modalview(modalName)');
          return;
        }

        var modalName = (0, _removeLeadingSlash2.default)((0, _trim2.default)(rawModalName));

        if (modalName === '') {
          (0, _warn2.default)('modalName cannot be an empty string or a single / in .modalview()');
          return;
        }

        if (typeof ga === 'function') {
          var path = '/modal/' + modalName;
          _gaCommand(trackerNames, 'send', 'pageview', path);

          if (_debug) {
            (0, _log2.default)('called ga(\'send\', \'pageview\', path);');
            (0, _log2.default)('with path: ' + path);
          }
        }
      }

      /**
       * timing:
       * GA timing
       * @param args.category {String} required
       * @param args.variable {String} required
       * @param args.value  {Int}  required
       * @param args.label  {String} required
       * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
       */
      function timing() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            category = _ref.category,
            variable = _ref.variable,
            value = _ref.value,
            label = _ref.label;

        var trackerNames = arguments[1];

        if (typeof ga === 'function') {
          if (!category || !variable || !value || typeof value !== 'number') {
            (0, _warn2.default)('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
            return;
          }

          // Required Fields
          var fieldObject = {
            hitType: 'timing',
            timingCategory: _format(category),
            timingVar: _format(variable),
            timingValue: value
          };

          if (label) {
            fieldObject.timingLabel = _format(label);
          }

          send(fieldObject, trackerNames);
        }
      }

      /**
       * event:
       * GA event tracking
       * @param args.category {String} required
       * @param args.action {String} required
       * @param args.label {String} optional
       * @param args.value {Int} optional
       * @param args.nonInteraction {boolean} optional
       * @param args.transport {string} optional
       * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
       */
      function event() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var trackerNames = arguments[1];

        var category = _ref2.category,
            action = _ref2.action,
            label = _ref2.label,
            value = _ref2.value,
            nonInteraction = _ref2.nonInteraction,
            transport = _ref2.transport,
            args = _objectWithoutProperties(_ref2, ['category', 'action', 'label', 'value', 'nonInteraction', 'transport']);

        if (typeof ga === 'function') {
          // Simple Validation
          if (!category || !action) {
            (0, _warn2.default)('args.category AND args.action are required in event()');
            return;
          }

          // Required Fields
          var fieldObject = {
            hitType: 'event',
            eventCategory: _format(category),
            eventAction: _format(action)
          };

          // Optional Fields
          if (label) {
            fieldObject.eventLabel = _format(label);
          }

          if (typeof value !== 'undefined') {
            if (typeof value !== 'number') {
              (0, _warn2.default)('Expected `args.value` arg to be a Number.');
            } else {
              fieldObject.eventValue = value;
            }
          }

          if (typeof nonInteraction !== 'undefined') {
            if (typeof nonInteraction !== 'boolean') {
              (0, _warn2.default)('`args.nonInteraction` must be a boolean.');
            } else {
              fieldObject.nonInteraction = nonInteraction;
            }
          }

          if (typeof transport !== 'undefined') {
            if (typeof transport !== 'string') {
              (0, _warn2.default)('`args.transport` must be a string.');
            } else {
              if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
                (0, _warn2.default)('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
              }

              fieldObject.transport = transport;
            }
          }

          Object.keys(args).filter(function (key) {
            return key.substr(0, 'dimension'.length) === 'dimension';
          }).forEach(function (key) {
            fieldObject[key] = args[key];
          });

          Object.keys(args).filter(function (key) {
            return key.substr(0, 'metric'.length) === 'metric';
          }).forEach(function (key) {
            fieldObject[key] = args[key];
          });

          // Send to GA
          send(fieldObject, trackerNames);
        }
      }

      /**
       * exception:
       * GA exception tracking
       * @param args.description {String} optional
       * @param args.fatal {boolean} optional
       * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
       */
      function exception(_ref3, trackerNames) {
        var description = _ref3.description,
            fatal = _ref3.fatal;

        if (typeof ga === 'function') {
          // Required Fields
          var fieldObject = {
            hitType: 'exception'
          };

          // Optional Fields
          if (description) {
            fieldObject.exDescription = _format(description);
          }

          if (typeof fatal !== 'undefined') {
            if (typeof fatal !== 'boolean') {
              (0, _warn2.default)('`args.fatal` must be a boolean.');
            } else {
              fieldObject.exFatal = fatal;
            }
          }

          // Send to GA
          send(fieldObject, trackerNames);
        }
      }

      var plugin = exports.plugin = {
        /**
         * require:
         * GA requires a plugin
         * @param name {String} e.g. 'ecommerce' or 'myplugin'
         * @param options {Object} optional e.g {path: '/log', debug: true}
         */
        require: function require(rawName, options) {
          if (typeof ga === 'function') {
            // Required Fields
            if (!rawName) {
              (0, _warn2.default)('`name` is required in .require()');
              return;
            }

            var name = (0, _trim2.default)(rawName);
            if (name === '') {
              (0, _warn2.default)('`name` cannot be an empty string in .require()');
              return;
            }

            // Optional Fields
            if (options) {
              if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
                (0, _warn2.default)('Expected `options` arg to be an Object');
                return;
              }

              if (Object.keys(options).length === 0) {
                (0, _warn2.default)('Empty `options` given to .require()');
              }

              ga('require', name, options);

              if (_debug) {
                (0, _log2.default)('called ga(\'require\', \'' + name + '\', ' + JSON.stringify(options));
              }
            } else {
              ga('require', name);

              if (_debug) {
                (0, _log2.default)('called ga(\'require\', \'' + name + '\');');
              }
            }
          }
        },

        /**
         * execute:
         * GA execute action for plugin
         * Takes variable number of arguments
         * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
         * @param action {String} e.g. 'addItem' or 'myCustomAction'
         * @param actionType {String} optional e.g. 'detail'
         * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
         */
        execute: function execute(pluginName, action) {
          var payload = void 0;
          var actionType = void 0;

          if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
            payload = arguments.length <= 2 ? undefined : arguments[2];
          } else {
            actionType = arguments.length <= 2 ? undefined : arguments[2];
            payload = arguments.length <= 3 ? undefined : arguments[3];
          }

          if (typeof ga === 'function') {
            if (typeof pluginName !== 'string') {
              (0, _warn2.default)('Expected `pluginName` arg to be a String.');
            } else if (typeof action !== 'string') {
              (0, _warn2.default)('Expected `action` arg to be a String.');
            } else {
              var command = pluginName + ':' + action;
              payload = payload || null;
              if (actionType && payload) {
                ga(command, actionType, payload);
                if (_debug) {
                  (0, _log2.default)('called ga(\'' + command + '\');');
                  (0, _log2.default)('actionType: "' + actionType + '" with payload: ' + JSON.stringify(payload));
                }
              } else if (payload) {
                ga(command, payload);
                if (_debug) {
                  (0, _log2.default)('called ga(\'' + command + '\');');
                  (0, _log2.default)('with payload: ' + JSON.stringify(payload));
                }
              } else {
                ga(command);
                if (_debug) {
                  (0, _log2.default)('called ga(\'' + command + '\');');
                }
              }
            }
          }
        }
      };

      /**
       * outboundLink:
       * GA outboundLink tracking
       * @param args.label {String} e.g. url, or 'Create an Account'
       * @param {function} hitCallback - Called after processing a hit.
       */
      function outboundLink(args, hitCallback, trackerNames) {
        if (typeof hitCallback !== 'function') {
          (0, _warn2.default)('hitCallback function is required');
          return;
        }

        if (typeof ga === 'function') {
          // Simple Validation
          if (!args || !args.label) {
            (0, _warn2.default)('args.label is required in outboundLink()');
            return;
          }

          // Required Fields
          var fieldObject = {
            hitType: 'event',
            eventCategory: 'Outbound',
            eventAction: 'Click',
            eventLabel: _format(args.label)
          };

          var safetyCallbackCalled = false;
          var safetyCallback = function safetyCallback() {
            // This prevents a delayed response from GA
            // causing hitCallback from being fired twice
            safetyCallbackCalled = true;

            hitCallback();
          };

          // Using a timeout to ensure the execution of critical application code
          // in the case when the GA server might be down
          // or an ad blocker prevents sending the data

          // register safety net timeout:
          var t = setTimeout(safetyCallback, 250);

          var clearableCallbackForGA = function clearableCallbackForGA() {
            clearTimeout(t);
            if (!safetyCallbackCalled) {
              hitCallback();
            }
          };

          fieldObject.hitCallback = clearableCallbackForGA;

          // Send to GA
          send(fieldObject, trackerNames);
        } else {
          // if ga is not defined, return the callback so the application
          // continues to work as expected
          setTimeout(hitCallback, 0);
        }
      }

      _OutboundLink2.default.origTrackLink = _OutboundLink2.default.trackLink;
      _OutboundLink2.default.trackLink = outboundLink;
      var OutboundLink = exports.OutboundLink = _OutboundLink2.default;
      var testModeAPI = exports.testModeAPI = _testModeAPI2.default;

      exports.default = {
        initialize: initialize,
        ga: ga,
        set: set,
        send: send,
        pageview: pageview,
        modalview: modalview,
        timing: timing,
        event: event,
        exception: exception,
        plugin: plugin,
        outboundLink: outboundLink,
        OutboundLink: OutboundLink,
        testModeAPI: _testModeAPI2.default
      };

      /***/
    },
    /* 3 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = format;

      var _mightBeEmail = __webpack_require__(4);

      var _mightBeEmail2 = _interopRequireDefault(_mightBeEmail);

      var _toTitleCase = __webpack_require__(5);

      var _toTitleCase2 = _interopRequireDefault(_toTitleCase);

      var _warn = __webpack_require__(0);

      var _warn2 = _interopRequireDefault(_warn);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      var redacted = 'REDACTED (Potential Email Address)';

      function format(s, titleCase) {
        if ((0, _mightBeEmail2.default)(s)) {
          (0, _warn2.default)('This arg looks like an email address, redacting.');
          return redacted;
        }

        if (titleCase) {
          return (0, _toTitleCase2.default)(s);
        }

        return s;
      }

      /***/
    },
    /* 4 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = mightBeEmail;
      // See if s could be an email address. We don't want to send personal data like email.
      // https://support.google.com/analytics/answer/2795983?hl=en
      function mightBeEmail(s) {
        // There's no point trying to validate rfc822 fully, just look for ...@...
        return (/[^@]+@[^@]+/.test(s)
        );
      }

      /***/
    },
    /* 5 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = toTitleCase;

      var _trim = __webpack_require__(1);

      var _trim2 = _interopRequireDefault(_trim);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i; /**
                                                                                                      * To Title Case 2.1 - http://individed.com/code/to-title-case/
                                                                                                      * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
                                                                                                      * https://github.com/gouch/to-title-case
                                                                                                      */

      function toTitleCase(string) {
        return (0, _trim2.default)(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
          if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
            return match.toLowerCase();
          }

          if (match.substr(1).search(/[A-Z]|\../) > -1) {
            return match;
          }

          return match.charAt(0).toUpperCase() + match.substr(1);
        });
      }

      /***/
    },
    /* 6 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = removeLeadingSlash;
      function removeLeadingSlash(string) {
        if (string.substring(0, 1) === '/') {
          return string.substring(1);
        }

        return string;
      }

      /***/
    },
    /* 7 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      exports.default = function (options) {
        // https://developers.google.com/analytics/devguides/collection/analyticsjs/
        /* eslint-disable */
        (function (i, s, o, g, r, a, m) {
          i['GoogleAnalyticsObject'] = r;
          i[r] = i[r] || function () {
            (i[r].q = i[r].q || []).push(arguments);
          }, i[r].l = 1 * new Date();
          a = s.createElement(o), m = s.getElementsByTagName(o)[0];
          a.async = 1;
          a.src = g;
          m.parentNode.insertBefore(a, m);
        })(window, document, 'script', options && options.gaAddress ? options.gaAddress : 'https://www.google-analytics.com/analytics.js', 'ga');
        /* eslint-enable */
      };

      /***/
    },
    /* 8 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = log;
      function log(s) {
        console.info('[react-ga]', s);
      }

      /***/
    },
    /* 9 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var gaCalls = exports.gaCalls = [];

      exports.default = {
        calls: gaCalls,
        ga: function ga() {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          gaCalls.push([].concat(args));
        }
      };

      /***/
    },
    /* 10 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }return target;
      };

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _react = __webpack_require__(11);

      var _react2 = _interopRequireDefault(_react);

      var _propTypes = __webpack_require__(12);

      var _propTypes2 = _interopRequireDefault(_propTypes);

      var _warn = __webpack_require__(0);

      var _warn2 = _interopRequireDefault(_warn);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var NEWTAB = '_blank';
      var MIDDLECLICK = 1;

      var OutboundLink = function (_Component) {
        _inherits(OutboundLink, _Component);

        function OutboundLink() {
          var _ref;

          var _temp, _this, _ret;

          _classCallCheck(this, OutboundLink);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = OutboundLink.__proto__ || Object.getPrototypeOf(OutboundLink)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
            var _this$props = _this.props,
                target = _this$props.target,
                eventLabel = _this$props.eventLabel,
                to = _this$props.to,
                onClick = _this$props.onClick;

            var eventMeta = { label: eventLabel };
            var sameTarget = target !== NEWTAB;
            var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);

            if (sameTarget && normalClick) {
              event.preventDefault();
              OutboundLink.trackLink(eventMeta, function () {
                window.location.href = to;
              });
            } else {
              OutboundLink.trackLink(eventMeta, function () {});
            }

            if (onClick) {
              onClick(event);
            }
          }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(OutboundLink, [{
          key: 'render',
          value: function render() {
            var props = _extends({}, this.props, {
              href: this.props.to,
              onClick: this.handleClick
            });
            delete props.eventLabel;
            return _react2.default.createElement('a', props);
          }
        }]);

        return OutboundLink;
      }(_react.Component);

      OutboundLink.propTypes = {
        eventLabel: _propTypes2.default.string.isRequired,
        target: _propTypes2.default.string,
        to: _propTypes2.default.string,
        onClick: _propTypes2.default.func
      };
      OutboundLink.defaultProps = {
        target: null,
        to: null,
        onClick: null
      };

      OutboundLink.trackLink = function () {
        (0, _warn2.default)('ga tracking not enabled');
      };

      exports.default = OutboundLink;

      /***/
    },
    /* 11 */
    /***/function (module, exports) {

      module.exports = __WEBPACK_EXTERNAL_MODULE_11__;

      /***/
    },
    /* 12 */
    /***/function (module, exports) {

      module.exports = __WEBPACK_EXTERNAL_MODULE_12__;

      /***/
    }]
    /******/)
  );
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("l262")(module)))

/***/ }),

/***/ "Zuzs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("KM04");

var _loader = __webpack_require__("KgDl");

var _loader2 = _interopRequireDefault(_loader);

var _config = __webpack_require__("MmR0");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CampaignRedirect = function (_Component) {
  _inherits(CampaignRedirect, _Component);

  function CampaignRedirect() {
    _classCallCheck(this, CampaignRedirect);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  CampaignRedirect.prototype.componentWillMount = function componentWillMount() {
    console.log('Redirecting to', _config2.default.campaign.url + '/c/' + this.props.matches.campaignUid + '?utm_source=trouble');
    location.href = _config2.default.campaign.url + '/c/' + this.props.matches.campaignUid + '?utm_source=trouble';
  };

  CampaignRedirect.prototype.render = function render() {
    return (0, _preact.h)(
      'div',
      null,
      (0, _preact.h)(_loader2.default, null),
      (0, _preact.h)(
        'p',
        { className: 'redirect' },
        'If you aren\'t redirected in 5 seconds then please ',
        (0, _preact.h)(
          'a',
          { href: _config2.default.campaign.url + '/c/' + this.props.matches.campaignUid + '?utm_source=trouble' },
          'Click here'
        )
      )
    );
  };

  return CampaignRedirect;
}(_preact.Component);

exports.default = CampaignRedirect;

/***/ }),

/***/ "avpp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var tester = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-?\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
// Thanks to:
// http://fightingforalostcause.net/misc/2006/compare-email-regex.php
// http://thedailywtf.com/Articles/Validating_Email_Addresses.aspx
// http://stackoverflow.com/questions/201323/what-is-the-best-regular-expression-for-validating-email-addresses/201378#201378
exports.validate = function (email) {
	if (!email) return false;

	if (email.length > 254) return false;

	var valid = tester.test(email);
	if (!valid) return false;

	// Further checking of some things regex can't handle
	var parts = email.split("@");
	if (parts[0].length > 64) return false;

	var domainParts = parts[1].split(".");
	if (domainParts.some(function (part) {
		return part.length > 63;
	})) return false;

	return true;
};

/***/ }),

/***/ "bdl5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__372gh","error":"error__2sbyk","icon":"icon__2jc1Q","message":"message__3Nt5l","info":"info__RXyn3","success":"success__KM_-3"};

/***/ }),

/***/ "cWBa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__2hmBL","content":"content__1228s","bar":"bar__2wFkL","heads":"heads__2rI8v","title":"title__3tGpl"};

/***/ }),

/***/ "dwPy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("KM04");

var _content = __webpack_require__("2AfE");

var _content2 = _interopRequireDefault(_content);

var _border = __webpack_require__("nZ5c");

var _border2 = _interopRequireDefault(_border);

var _header = __webpack_require__("Aa1G");

var _header2 = _interopRequireDefault(_header);

var _hero = __webpack_require__("9dvf");

var _hero2 = _interopRequireDefault(_hero);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Hero = function (_Component) {
  _inherits(Hero, _Component);

  function Hero() {
    _classCallCheck(this, Hero);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Hero.prototype.render = function render() {
    return (0, _preact.h)(
      'div',
      { className: _hero2.default.container },
      (0, _preact.h)(_header2.default, null),
      (0, _preact.h)(
        _content2.default,
        null,
        (0, _preact.h)(
          'div',
          { className: _hero2.default.text },
          (0, _preact.h)(
            'h2',
            { className: _hero2.default.title },
            'You\'ve found trouble!'
          ),
          (0, _preact.h)(
            'h2',
            { className: _hero2.default.subTitle },
            'Personalised brewing for businesses and events, both big and small'
          )
        )
      ),
      (0, _preact.h)(_border2.default, { color: 'white' })
    );
  };

  return Hero;
}(_preact.Component);

exports.default = Hero;

/***/ }),

/***/ "eW0v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.__spread = exports.unstable_renderSubtreeIntoContainer = exports.PureComponent = exports.Component = exports.unmountComponentAtNode = exports.findDOMNode = exports.isValidElement = exports.cloneElement = exports.createElement = exports.createFactory = exports.createClass = exports.render = exports.Children = exports.PropTypes = exports.DOM = exports.version = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _propTypes = __webpack_require__("5D9O");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _preact = __webpack_require__("KM04");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var version = '15.1.0'; // trick libraries to think we are react

var ELEMENTS = 'a abbr address area article aside audio b base bdi bdo big blockquote body br button canvas caption cite code col colgroup data datalist dd del details dfn dialog div dl dt em embed fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup hr html i iframe img input ins kbd keygen label legend li link main map mark menu menuitem meta meter nav noscript object ol optgroup option output p param picture pre progress q rp rt ruby s samp script section select small source span strong style sub summary sup table tbody td textarea tfoot th thead time title tr track u ul var video wbr circle clipPath defs ellipse g image line linearGradient mask path pattern polygon polyline radialGradient rect stop svg text tspan'.split(' ');

var REACT_ELEMENT_TYPE = typeof Symbol !== 'undefined' && Symbol.for && Symbol.for('react.element') || 0xeac7;

var COMPONENT_WRAPPER_KEY = typeof Symbol !== 'undefined' && Symbol.for ? Symbol.for('__preactCompatWrapper') : '__preactCompatWrapper';

// don't autobind these methods since they already have guaranteed context.
var AUTOBIND_BLACKLIST = {
	constructor: 1,
	render: 1,
	shouldComponentUpdate: 1,
	componentWillReceiveProps: 1,
	componentWillUpdate: 1,
	componentDidUpdate: 1,
	componentWillMount: 1,
	componentDidMount: 1,
	componentWillUnmount: 1,
	componentDidUnmount: 1
};

var CAMEL_PROPS = /^(?:accent|alignment|arabic|baseline|cap|clip|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vector|vert|word|writing|x)[A-Z]/;

var BYPASS_HOOK = {};

/*global process*/
var DEV = typeof process === 'undefined' || !process.env || "production" !== 'production';

// a component that renders nothing. Used to replace components for unmountComponentAtNode.
function EmptyComponent() {
	return null;
}

// make react think we're react.
var VNode = (0, _preact.h)('a', null).constructor;
VNode.prototype.$$typeof = REACT_ELEMENT_TYPE;
VNode.prototype.preactCompatUpgraded = false;
VNode.prototype.preactCompatNormalized = false;

Object.defineProperty(VNode.prototype, 'type', {
	get: function get() {
		return this.nodeName;
	},
	set: function set(v) {
		this.nodeName = v;
	},
	configurable: true
});

Object.defineProperty(VNode.prototype, 'props', {
	get: function get() {
		return this.attributes;
	},
	set: function set(v) {
		this.attributes = v;
	},
	configurable: true
});

var oldEventHook = _preact.options.event;
_preact.options.event = function (e) {
	if (oldEventHook) {
		e = oldEventHook(e);
	}
	e.persist = Object;
	e.nativeEvent = e;
	return e;
};

var oldVnodeHook = _preact.options.vnode;
_preact.options.vnode = function (vnode) {
	if (!vnode.preactCompatUpgraded) {
		vnode.preactCompatUpgraded = true;

		var tag = vnode.nodeName,
		    attrs = vnode.attributes = extend({}, vnode.attributes);

		if (typeof tag === 'function') {
			if (tag[COMPONENT_WRAPPER_KEY] === true || tag.prototype && 'isReactComponent' in tag.prototype) {
				if (vnode.children && String(vnode.children) === '') {
					vnode.children = undefined;
				}
				if (vnode.children) {
					attrs.children = vnode.children;
				}

				if (!vnode.preactCompatNormalized) {
					normalizeVNode(vnode);
				}
				handleComponentVNode(vnode);
			}
		} else {
			if (vnode.children && String(vnode.children) === '') {
				vnode.children = undefined;
			}
			if (vnode.children) {
				attrs.children = vnode.children;
			}

			if (attrs.defaultValue) {
				if (!attrs.value && attrs.value !== 0) {
					attrs.value = attrs.defaultValue;
				}
				delete attrs.defaultValue;
			}

			handleElementVNode(vnode, attrs);
		}
	}

	if (oldVnodeHook) {
		oldVnodeHook(vnode);
	}
};

function handleComponentVNode(vnode) {
	var tag = vnode.nodeName,
	    a = vnode.attributes;

	vnode.attributes = {};
	if (tag.defaultProps) {
		extend(vnode.attributes, tag.defaultProps);
	}
	if (a) {
		extend(vnode.attributes, a);
	}
}

function handleElementVNode(vnode, a) {
	var shouldSanitize, attrs, i;
	if (a) {
		for (i in a) {
			if (shouldSanitize = CAMEL_PROPS.test(i)) {
				break;
			}
		}
		if (shouldSanitize) {
			attrs = vnode.attributes = {};
			for (i in a) {
				if (a.hasOwnProperty(i)) {
					attrs[CAMEL_PROPS.test(i) ? i.replace(/([A-Z0-9])/, '-$1').toLowerCase() : i] = a[i];
				}
			}
		}
	}
}

// proxy render() since React returns a Component reference.
function render$1(vnode, parent, callback) {
	var prev = parent && parent._preactCompatRendered && parent._preactCompatRendered.base;

	// ignore impossible previous renders
	if (prev && prev.parentNode !== parent) {
		prev = null;
	}

	// default to first Element child
	if (!prev && parent) {
		prev = parent.firstElementChild;
	}

	// remove unaffected siblings
	for (var i = parent.childNodes.length; i--;) {
		if (parent.childNodes[i] !== prev) {
			parent.removeChild(parent.childNodes[i]);
		}
	}

	var out = (0, _preact.render)(vnode, parent, prev);
	if (parent) {
		parent._preactCompatRendered = out && (out._component || { base: out });
	}
	if (typeof callback === 'function') {
		callback();
	}
	return out && out._component || out;
}

var ContextProvider = function ContextProvider() {};

ContextProvider.prototype.getChildContext = function () {
	return this.props.context;
};
ContextProvider.prototype.render = function (props) {
	return props.children[0];
};

function renderSubtreeIntoContainer(parentComponent, vnode, container, callback) {
	var wrap = (0, _preact.h)(ContextProvider, { context: parentComponent.context }, vnode);
	var renderContainer = render$1(wrap, container);
	var component = renderContainer._component || renderContainer.base;
	if (callback) {
		callback.call(component, renderContainer);
	}
	return component;
}

function unmountComponentAtNode(container) {
	var existing = container._preactCompatRendered && container._preactCompatRendered.base;
	if (existing && existing.parentNode === container) {
		(0, _preact.render)((0, _preact.h)(EmptyComponent), container, existing);
		return true;
	}
	return false;
}

var ARR = [];

// This API is completely unnecessary for Preact, so it's basically passthrough.
var Children = {
	map: function map(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		return children.map(fn);
	},
	forEach: function forEach(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		children.forEach(fn);
	},
	count: function count(children) {
		return children && children.length || 0;
	},
	only: function only(children) {
		children = Children.toArray(children);
		if (children.length !== 1) {
			throw new Error('Children.only() expects only one child.');
		}
		return children[0];
	},
	toArray: function toArray(children) {
		if (children == null) {
			return [];
		}
		return ARR.concat(children);
	}
};

/** Track current render() component for ref assignment */
var currentComponent;

function createFactory(type) {
	return createElement.bind(null, type);
}

var DOM = {};
for (var i = ELEMENTS.length; i--;) {
	DOM[ELEMENTS[i]] = createFactory(ELEMENTS[i]);
}

function upgradeToVNodes(arr, offset) {
	for (var i = offset || 0; i < arr.length; i++) {
		var obj = arr[i];
		if (Array.isArray(obj)) {
			upgradeToVNodes(obj);
		} else if (obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && !isValidElement(obj) && (obj.props && obj.type || obj.attributes && obj.nodeName || obj.children)) {
			arr[i] = createElement(obj.type || obj.nodeName, obj.props || obj.attributes, obj.children);
		}
	}
}

function isStatelessComponent(c) {
	return typeof c === 'function' && !(c.prototype && c.prototype.render);
}

// wraps stateless functional components in a PropTypes validator
function wrapStatelessComponent(WrappedComponent) {
	return createClass({
		displayName: WrappedComponent.displayName || WrappedComponent.name,
		render: function render() {
			return WrappedComponent(this.props, this.context);
		}
	});
}

function statelessComponentHook(Ctor) {
	var Wrapped = Ctor[COMPONENT_WRAPPER_KEY];
	if (Wrapped) {
		return Wrapped === true ? Ctor : Wrapped;
	}

	Wrapped = wrapStatelessComponent(Ctor);

	Object.defineProperty(Wrapped, COMPONENT_WRAPPER_KEY, { configurable: true, value: true });
	Wrapped.displayName = Ctor.displayName;
	Wrapped.propTypes = Ctor.propTypes;
	Wrapped.defaultProps = Ctor.defaultProps;

	Object.defineProperty(Ctor, COMPONENT_WRAPPER_KEY, { configurable: true, value: Wrapped });

	return Wrapped;
}

function createElement() {
	var args = [],
	    len = arguments.length;
	while (len--) {
		args[len] = arguments[len];
	}upgradeToVNodes(args, 2);
	return normalizeVNode(_preact.h.apply(void 0, args));
}

function normalizeVNode(vnode) {
	vnode.preactCompatNormalized = true;

	applyClassName(vnode);

	if (isStatelessComponent(vnode.nodeName)) {
		vnode.nodeName = statelessComponentHook(vnode.nodeName);
	}

	var ref = vnode.attributes.ref,
	    type = ref && (typeof ref === 'undefined' ? 'undefined' : _typeof(ref));
	if (currentComponent && (type === 'string' || type === 'number')) {
		vnode.attributes.ref = createStringRefProxy(ref, currentComponent);
	}

	applyEventNormalization(vnode);

	return vnode;
}

function cloneElement$1(element, props) {
	var children = [],
	    len = arguments.length - 2;
	while (len-- > 0) {
		children[len] = arguments[len + 2];
	}if (!isValidElement(element)) {
		return element;
	}
	var elementProps = element.attributes || element.props;
	var node = (0, _preact.h)(element.nodeName || element.type, extend({}, elementProps), element.children || elementProps && elementProps.children);
	// Only provide the 3rd argument if needed.
	// Arguments 3+ overwrite element.children in preactCloneElement
	var cloneArgs = [node, props];
	if (children && children.length) {
		cloneArgs.push(children);
	} else if (props && props.children) {
		cloneArgs.push(props.children);
	}
	return normalizeVNode(_preact.cloneElement.apply(void 0, cloneArgs));
}

function isValidElement(element) {
	return element && (element instanceof VNode || element.$$typeof === REACT_ELEMENT_TYPE);
}

function createStringRefProxy(name, component) {
	return component._refProxies[name] || (component._refProxies[name] = function (resolved) {
		if (component && component.refs) {
			component.refs[name] = resolved;
			if (resolved === null) {
				delete component._refProxies[name];
				component = null;
			}
		}
	});
}

function applyEventNormalization(ref) {
	var nodeName = ref.nodeName;
	var attributes = ref.attributes;

	if (!attributes || typeof nodeName !== 'string') {
		return;
	}
	var props = {};
	for (var i in attributes) {
		props[i.toLowerCase()] = i;
	}
	if (props.ondoubleclick) {
		attributes.ondblclick = attributes[props.ondoubleclick];
		delete attributes[props.ondoubleclick];
	}
	// for *textual inputs* (incl textarea), normalize `onChange` -> `onInput`:
	if (props.onchange && (nodeName === 'textarea' || nodeName.toLowerCase() === 'input' && !/^fil|che|rad/i.test(attributes.type))) {
		var normalized = props.oninput || 'oninput';
		if (!attributes[normalized]) {
			attributes[normalized] = multihook([attributes[normalized], attributes[props.onchange]]);
			delete attributes[props.onchange];
		}
	}
}

function applyClassName(vnode) {
	var a = vnode.attributes || (vnode.attributes = {});
	classNameDescriptor.enumerable = 'className' in a;
	if (a.className) {
		a.class = a.className;
	}
	Object.defineProperty(a, 'className', classNameDescriptor);
}

var classNameDescriptor = {
	configurable: true,
	get: function get() {
		return this.class;
	},
	set: function set(v) {
		this.class = v;
	}
};

function extend(base, props) {
	var arguments$1 = arguments;

	for (var i = 1, obj = void 0; i < arguments.length; i++) {
		if (obj = arguments$1[i]) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					base[key] = obj[key];
				}
			}
		}
	}
	return base;
}

function shallowDiffers(a, b) {
	for (var i in a) {
		if (!(i in b)) {
			return true;
		}
	}
	for (var i$1 in b) {
		if (a[i$1] !== b[i$1]) {
			return true;
		}
	}
	return false;
}

function findDOMNode(component) {
	return component && component.base || component;
}

function F() {}

function createClass(obj) {
	function cl(props, context) {
		bindAll(this);
		Component$1.call(this, props, context, BYPASS_HOOK);
		newComponentHook.call(this, props, context);
	}

	obj = extend({ constructor: cl }, obj);

	// We need to apply mixins here so that getDefaultProps is correctly mixed
	if (obj.mixins) {
		applyMixins(obj, collateMixins(obj.mixins));
	}
	if (obj.statics) {
		extend(cl, obj.statics);
	}
	if (obj.propTypes) {
		cl.propTypes = obj.propTypes;
	}
	if (obj.defaultProps) {
		cl.defaultProps = obj.defaultProps;
	}
	if (obj.getDefaultProps) {
		cl.defaultProps = obj.getDefaultProps.call(cl);
	}

	F.prototype = Component$1.prototype;
	cl.prototype = extend(new F(), obj);

	cl.displayName = obj.displayName || 'Component';

	return cl;
}

// Flatten an Array of mixins to a map of method name to mixin implementations
function collateMixins(mixins) {
	var keyed = {};
	for (var i = 0; i < mixins.length; i++) {
		var mixin = mixins[i];
		for (var key in mixin) {
			if (mixin.hasOwnProperty(key) && typeof mixin[key] === 'function') {
				(keyed[key] || (keyed[key] = [])).push(mixin[key]);
			}
		}
	}
	return keyed;
}

// apply a mapping of Arrays of mixin methods to a component prototype
function applyMixins(proto, mixins) {
	for (var key in mixins) {
		if (mixins.hasOwnProperty(key)) {
			proto[key] = multihook(mixins[key].concat(proto[key] || ARR), key === 'getDefaultProps' || key === 'getInitialState' || key === 'getChildContext');
		}
	}
}

function bindAll(ctx) {
	for (var i in ctx) {
		var v = ctx[i];
		if (typeof v === 'function' && !v.__bound && !AUTOBIND_BLACKLIST.hasOwnProperty(i)) {
			(ctx[i] = v.bind(ctx)).__bound = true;
		}
	}
}

function callMethod(ctx, m, args) {
	if (typeof m === 'string') {
		m = ctx.constructor.prototype[m];
	}
	if (typeof m === 'function') {
		return m.apply(ctx, args);
	}
}

function multihook(hooks, skipDuplicates) {
	return function () {
		var arguments$1 = arguments;
		var this$1 = this;

		var ret;
		for (var i = 0; i < hooks.length; i++) {
			var r = callMethod(this$1, hooks[i], arguments$1);

			if (skipDuplicates && r != null) {
				if (!ret) {
					ret = {};
				}
				for (var key in r) {
					if (r.hasOwnProperty(key)) {
						ret[key] = r[key];
					}
				}
			} else if (typeof r !== 'undefined') {
				ret = r;
			}
		}
		return ret;
	};
}

function newComponentHook(props, context) {
	propsHook.call(this, props, context);
	this.componentWillReceiveProps = multihook([propsHook, this.componentWillReceiveProps || 'componentWillReceiveProps']);
	this.render = multihook([propsHook, beforeRender, this.render || 'render', afterRender]);
}

function propsHook(props, context) {
	if (!props) {
		return;
	}

	// React annoyingly special-cases single children, and some react components are ridiculously strict about this.
	var c = props.children;
	if (c && Array.isArray(c) && c.length === 1 && (typeof c[0] === 'string' || typeof c[0] === 'function' || c[0] instanceof VNode)) {
		props.children = c[0];

		// but its totally still going to be an Array.
		if (props.children && _typeof(props.children) === 'object') {
			props.children.length = 1;
			props.children[0] = props.children;
		}
	}

	// add proptype checking
	if (DEV) {
		var ctor = typeof this === 'function' ? this : this.constructor,
		    propTypes = this.propTypes || ctor.propTypes;
		var displayName = this.displayName || ctor.name;

		if (propTypes) {
			_propTypes2.default.checkPropTypes(propTypes, props, 'prop', displayName);
		}
	}
}

function beforeRender(props) {
	currentComponent = this;
}

function afterRender() {
	if (currentComponent === this) {
		currentComponent = null;
	}
}

function Component$1(props, context, opts) {
	_preact.Component.call(this, props, context);
	this.state = this.getInitialState ? this.getInitialState() : {};
	this.refs = {};
	this._refProxies = {};
	if (opts !== BYPASS_HOOK) {
		newComponentHook.call(this, props, context);
	}
}
extend(Component$1.prototype = new _preact.Component(), {
	constructor: Component$1,

	isReactComponent: {},

	replaceState: function replaceState(state, callback) {
		var this$1 = this;

		this.setState(state, callback);
		for (var i in this$1.state) {
			if (!(i in state)) {
				delete this$1.state[i];
			}
		}
	},

	getDOMNode: function getDOMNode() {
		return this.base;
	},

	isMounted: function isMounted() {
		return !!this.base;
	}
});

function PureComponent(props, context) {
	Component$1.call(this, props, context);
}
F.prototype = Component$1.prototype;
PureComponent.prototype = new F();
PureComponent.prototype.isPureReactComponent = true;
PureComponent.prototype.shouldComponentUpdate = function (props, state) {
	return shallowDiffers(this.props, props) || shallowDiffers(this.state, state);
};

var index = {
	version: version,
	DOM: DOM,
	PropTypes: _propTypes2.default,
	Children: Children,
	render: render$1,
	createClass: createClass,
	createFactory: createFactory,
	createElement: createElement,
	cloneElement: cloneElement$1,
	isValidElement: isValidElement,
	findDOMNode: findDOMNode,
	unmountComponentAtNode: unmountComponentAtNode,
	Component: Component$1,
	PureComponent: PureComponent,
	unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer,
	__spread: extend
};

exports.version = version;
exports.DOM = DOM;
exports.PropTypes = _propTypes2.default;
exports.Children = Children;
exports.render = render$1;
exports.createClass = createClass;
exports.createFactory = createFactory;
exports.createElement = createElement;
exports.cloneElement = cloneElement$1;
exports.isValidElement = isValidElement;
exports.findDOMNode = findDOMNode;
exports.unmountComponentAtNode = unmountComponentAtNode;
exports.Component = Component$1;
exports.PureComponent = PureComponent;
exports.unstable_renderSubtreeIntoContainer = renderSubtreeIntoContainer;
exports.__spread = extend;
exports.default = index;
//# sourceMappingURL=preact-compat.es.js.map

/***/ }),

/***/ "gvtp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0788209b3bf53a388390283b6de1db3e.svg";

/***/ }),

/***/ "h1h4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("KM04");

var _content = __webpack_require__("2AfE");

var _content2 = _interopRequireDefault(_content);

var _border = __webpack_require__("nZ5c");

var _border2 = _interopRequireDefault(_border);

var _about = __webpack_require__("cWBa");

var _about2 = _interopRequireDefault(_about);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var About = function (_Component) {
  _inherits(About, _Component);

  function About() {
    _classCallCheck(this, About);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  About.prototype.render = function render() {
    return (0, _preact.h)(
      'div',
      { className: _about2.default.container, id: 'page-about' },
      (0, _preact.h)(
        _content2.default,
        null,
        (0, _preact.h)(
          'div',
          { className: 'flex ' + _about2.default.content },
          (0, _preact.h)('img', { className: _about2.default.heads, src: '/assets/heads.png', alt: 'Trouble Brewing' }),
          (0, _preact.h)(
            'div',
            null,
            (0, _preact.h)(
              'h2',
              { className: _about2.default.title },
              'Who we are'
            ),
            '\x03',
            (0, _preact.h)(
              'p',
              null,
              'We\u2019re a Singapore-based company that specialises in creating high quality beer that\u2019s personalised for businesses and events, big and small.'
            ),
            (0, _preact.h)(
              'p',
              null,
              'Our mission is to help brands promote themselves over great tasting beer \u2013 because we reckon the only thing better than doing business over a beer, is when it\u2019s your own branded beer. From the look of the bottle right down to the recipe and flavours, we can help you create the perfect brew for your brand.'
            ),
            (0, _preact.h)(
              'p',
              null,
              'Find out more about how we can brew some trouble for your business below...'
            )
          )
        )
      ),
      (0, _preact.h)(_border2.default, { color: 'red' })
    );
  };

  return About;
}(_preact.Component);

exports.default = About;

/***/ }),

/***/ "jYYg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("KM04");

var _border = __webpack_require__("nZ5c");

var _border2 = _interopRequireDefault(_border);

var _footer = __webpack_require__("KlFx");

var _footer2 = _interopRequireDefault(_footer);

var _content = __webpack_require__("2AfE");

var _content2 = _interopRequireDefault(_content);

var _trade = __webpack_require__("o15H");

var _trade2 = _interopRequireDefault(_trade);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Security = function (_Component) {
  _inherits(Security, _Component);

  function Security() {
    _classCallCheck(this, Security);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Security.prototype.render = function render() {
    return (0, _preact.h)(
      'div',
      null,
      (0, _preact.h)(
        'div',
        { className: _trade2.default.container },
        (0, _preact.h)(
          _content2.default,
          null,
          (0, _preact.h)(
            'div',
            { className: _trade2.default.text },
            (0, _preact.h)(
              'div',
              { className: 'flex' },
              (0, _preact.h)(
                'a',
                { href: '/' },
                (0, _preact.h)('img', { className: _trade2.default.logo, src: '/assets/logo-red.png', alt: 'Trouble Brewing' })
              ),
              (0, _preact.h)(
                'h1',
                { className: _trade2.default.title },
                'Security Policy Statement'
              )
            ),
            (0, _preact.h)(
              'p',
              null,
              'Trouble Brewing is committed to protecting the company\'s employees, properties, information, reputation and customer\'s assets from potential threats in the supply chain. This policy is guided by the company\u2019s basic core values, code of conduct, business ethics and supply chain security standards, and it dictates the way we operate throughout the supply chain. This Security Policy applies to individuals/entities that are provided access to information resources, including approved third party consultants, contractors and vendors.'
            ),
            (0, _preact.h)(
              'p',
              null,
              'All security activities must adhere to the general principles laid down below:'
            ),
            (0, _preact.h)(
              'ul',
              null,
              (0, _preact.h)(
                'li',
                null,
                'All employees and contractors must always be aware of and take responsibility for the security aspects of the company\u2019s business activities;'
              ),
              (0, _preact.h)(
                'li',
                null,
                'Threats analysis and risk evaluations should be conducted on a regular basis;'
              ),
              (0, _preact.h)(
                'li',
                null,
                'Security procedures and guidelines should be seamlessly integrated with business activities;'
              ),
              (0, _preact.h)(
                'li',
                null,
                'Security measures and procedures must be subject to regular inspections, validations and verifications as noted by the relevant Security Policy so as to maintain high security standards for all operations.'
              ),
              (0, _preact.h)(
                'li',
                null,
                'The level of professionalism, knowledge and integrity of staff involved in security matters must be tightly controlled and vetted.'
              ),
              (0, _preact.h)(
                'li',
                null,
                'Appropriate training plans, customer screening, recruitment, contracting and termination procedures must be established and implemented and documented.'
              ),
              (0, _preact.h)(
                'li',
                null,
                'All incidents, including security breaches and irregularities must be reported and recorded. Corrective action should be taken and followed up through regular verifications to improve the overall security standard.'
              )
            ),
            (0, _preact.h)(
              'p',
              null,
              'With regard to data/digital security specifically, the principle of role-based access control is applied at Trouble Brewing; only the employees with the authority and requirement to access information will do so. To this end:'
            ),
            (0, _preact.h)(
              'ul',
              null,
              (0, _preact.h)(
                'li',
                null,
                'Our standard operating procedures include requiring that employees who will have access to sensitive information are trained information security, as well as held up to a high ethical and compliance standard. '
              ),
              (0, _preact.h)(
                'li',
                null,
                'All Employee end-user machines have industry standard anti-virus software installed, which is updated and monitored regularly.'
              ),
              (0, _preact.h)(
                'li',
                null,
                'All data and activity will be stored in cloud-based software to ensure the veracity and secure storage/access of all data '
              ),
              (0, _preact.h)(
                'li',
                null,
                'Notwithstanding these protections, Trouble Brewing recognizes that all IT systems remain vulnerable to attack; therefore, monitoring is essential to ensure the reliability and security of all data'
              )
            ),
            (0, _preact.h)(
              'p',
              null,
              'This policy has been approved by the Management Directors at Trouble Brewing. It will be reviewed, and if necessary revised, annually to keep up to date and will be released on our company website. '
            )
          )
        ),
        (0, _preact.h)(_border2.default, { color: 'black' })
      ),
      (0, _preact.h)(_footer2.default, null)
    );
  };

  return Security;
}(_preact.Component);

exports.default = Security;

/***/ }),

/***/ "kv8w":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "57ce65737511d05c8ea5bf5e50b41659.svg";

/***/ }),

/***/ "l262":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),

/***/ "mvbk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _class, _temp2;

var _preact = __webpack_require__("KM04");

var _classnames = __webpack_require__("9qb7");

var _classnames2 = _interopRequireDefault(_classnames);

var _button = __webpack_require__("7Wgl");

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Button = (_temp2 = _class = function (_Component) {
  _inherits(Button, _Component);

  function Button() {
    var _temp, _this, _ret;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.clickHandler = function (event) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick;


      if (disabled) {
        event.preventDefault();
        return;
      }

      if (onClick) {
        onClick(event);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Button.prototype.render = function render() {
    var _cn;

    var _props = this.props,
        className = _props.className,
        children = _props.children,
        disabled = _props.disabled,
        submit = _props.submit,
        type = _props.type;

    var classes = (0, _classnames2.default)(_button2.default.button, _button2.default[type], className, (_cn = {}, _cn[_button2.default.disabled] = disabled, _cn));

    return (0, _preact.h)(
      'button',
      {
        disabled: disabled,
        type: submit ? 'submit' : 'button',
        className: classes,
        onClick: this.clickHandler },
      children
    );
  };

  return Button;
}(_preact.Component), _class.defaultProps = {
  type: 'primary'
}, _temp2);
exports.default = Button;

/***/ }),

/***/ "mw+q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"icon":"icon__2qeSS"};

/***/ }),

/***/ "nZ5c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("KM04");

var _border = __webpack_require__("Y6Xg");

var _border2 = _interopRequireDefault(_border);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Content = function (_Component) {
	_inherits(Content, _Component);

	function Content() {
		_classCallCheck(this, Content);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Content.prototype.render = function render(_ref) {
		var color = _ref.color;

		return (0, _preact.h)('span', { className: _border2.default.border + ' ' + _border2.default[color] });
	};

	return Content;
}(_preact.Component);

exports.default = Content;

/***/ }),

/***/ "o15H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__35CkW","text":"text__3lRoJ","logo":"logo__kBkJ6","title":"title__3jUdv"};

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (false) {
	navigator.serviceWorker.register(__webpack_public_path__ + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "q4w7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("KM04");

var _border = __webpack_require__("nZ5c");

var _border2 = _interopRequireDefault(_border);

var _content = __webpack_require__("2AfE");

var _content2 = _interopRequireDefault(_content);

var _contactForm = __webpack_require__("tMjC");

var _contactForm2 = _interopRequireDefault(_contactForm);

var _contact = __webpack_require__("HZyB");

var _contact2 = _interopRequireDefault(_contact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Contact = function (_Component) {
  _inherits(Contact, _Component);

  function Contact() {
    _classCallCheck(this, Contact);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Contact.prototype.render = function render() {
    return (0, _preact.h)(
      'div',
      { className: _contact2.default.container, id: 'page-contact' },
      (0, _preact.h)(
        _content2.default,
        { className: 'flex ' + _contact2.default.content },
        (0, _preact.h)(
          'div',
          { className: _contact2.default.textContainer },
          (0, _preact.h)(
            'h2',
            null,
            'Contact Us'
          ),
          (0, _preact.h)(
            'p',
            null,
            'We are a pretty easy going bunch and are happy to help customise the right solution for you. This could be anything from providing staff to pour the drink, working with select artists for label creation, through to hosting master brewing tasting sessions. Just drop us a line and we can help you out.'
          )
        ),
        (0, _preact.h)(
          'div',
          { className: _contact2.default.contactFormContainer + ' handDrawn' },
          (0, _preact.h)('img', { src: '/assets/text-hello-there.png', className: _contact2.default.helloText }),
          (0, _preact.h)('img', { src: '/assets/text-call-us.png', className: _contact2.default.callUsText }),
          (0, _preact.h)(_contactForm2.default, null)
        )
      ),
      (0, _preact.h)(_border2.default, { color: 'black' })
    );
  };

  return Contact;
}(_preact.Component);

exports.default = Contact;

/***/ }),

/***/ "qLaj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("KM04");

var _preactRouter = __webpack_require__("/QC5");

var _home = __webpack_require__("FRX4");

var _home2 = _interopRequireDefault(_home);

var _campaignRedirect = __webpack_require__("Zuzs");

var _campaignRedirect2 = _interopRequireDefault(_campaignRedirect);

var _trade = __webpack_require__("tKK3");

var _trade2 = _interopRequireDefault(_trade);

var _security = __webpack_require__("jYYg");

var _security2 = _interopRequireDefault(_security);

var _terms = __webpack_require__("rSWL");

var _terms2 = _interopRequireDefault(_terms);

var _privacy = __webpack_require__("5JYR");

var _privacy2 = _interopRequireDefault(_privacy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _history = history,
    pushState = _history.pushState;

history.pushState = function (a, b, url) {
  pushState.call(history, a, b, url);
  scrollTo(0, 0);
};

var App = function (_Component) {
  _inherits(App, _Component);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  App.prototype.render = function render() {
    return (0, _preact.h)(
      'div',
      { className: 'app' },
      (0, _preact.h)(
        _preactRouter.Router,
        null,
        (0, _preact.h)(_home2.default, { path: '/' }),
        (0, _preact.h)(_trade2.default, { path: '/trade' }),
        (0, _preact.h)(_security2.default, { path: '/security' }),
        (0, _preact.h)(_terms2.default, { path: '/terms' }),
        (0, _preact.h)(_privacy2.default, { path: '/privacy' }),
        (0, _preact.h)(_campaignRedirect2.default, { path: '/:campaignUid' })
      )
    );
  };

  return App;
}(_preact.Component);

exports.default = App;

/***/ }),

/***/ "rSWL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("KM04");

var _border = __webpack_require__("nZ5c");

var _border2 = _interopRequireDefault(_border);

var _footer = __webpack_require__("KlFx");

var _footer2 = _interopRequireDefault(_footer);

var _content = __webpack_require__("2AfE");

var _content2 = _interopRequireDefault(_content);

var _trade = __webpack_require__("o15H");

var _trade2 = _interopRequireDefault(_trade);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Terms = function (_Component) {
  _inherits(Terms, _Component);

  function Terms() {
    _classCallCheck(this, Terms);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Terms.prototype.render = function render() {
    return (0, _preact.h)(
      'div',
      null,
      (0, _preact.h)(
        'div',
        { className: _trade2.default.container },
        (0, _preact.h)(
          _content2.default,
          null,
          (0, _preact.h)(
            'div',
            { className: _trade2.default.text },
            (0, _preact.h)(
              'div',
              { className: 'flex' },
              (0, _preact.h)(
                'a',
                { href: '/' },
                (0, _preact.h)('img', { className: _trade2.default.logo, src: '/assets/logo-red.png', alt: 'Trouble Brewing' })
              ),
              (0, _preact.h)(
                'h1',
                { className: _trade2.default.title },
                'Terms and Conditions'
              )
            ),
            (0, _preact.h)(
              'p',
              null,
              'Last updated:\xA0',
              (0, _preact.h)(
                'strong',
                null,
                '9th February 2018'
              )
            ),
            (0, _preact.h)(
              'p',
              null,
              'Listen, if you\u2019re going to take the time to read this, the least we can do is try to make it as simple as possible. We\u2019ll have to have the legal speak as well (of course) but we\u2019ll give it to you as straight as we can.'
            ),
            (0, _preact.h)(
              'p',
              null,
              'Basically there are three big rules here:'
            ),
            (0, _preact.h)(
              'ol',
              null,
              (0, _preact.h)(
                'li',
                null,
                'You must be over 18 and of legal drinking age to use this site, interact with this site, order using this site, or accept beer on delivery from this. By doing any of the above, you are confirming that you\u2019re 18 and abide by the laws of Singapore.'
              ),
              (0, _preact.h)(
                'li',
                null,
                'Unless you state otherwise to us and we agree expressly, you\u2019re not allowed to on-sell any beer purchased from Trouble Brewing, and you\u2019re acknowledging that it\u2019s for your own personal use. '
              ),
              (0, _preact.h)(
                'li',
                null,
                'As a condition of using Trouble Brewing\u2019s website or social media channels (known from now as the \u201Csite\u201D), and any of Trouble Brewing\u2019s services (otherwise known as the \u201Cservices\u201D) you agree to comply and be bound/subject to all of our rules and terms and conditions. If you do not agree with these terms and conditions, please close your computer - and do not use the service.'
              )
            ),
            (0, _preact.h)(
              'p',
              null,
              'That\u2019s the main parts \u2013 and we reserve the right to refuse order/service to anyone that we deem is not complying with the above and it\u2019s at our sole discretion. No whinging.'
            ),
            (0, _preact.h)(
              'p',
              null,
              'Now here\u2019s some more of the technical stuff you\u2019re also going to need to know, read on!'
            ),
            (0, _preact.h)(
              'p',
              null,
              'Also, any rules or terms and conditions you see here might change \u2013 so anytime you use the service, you will constitute your acceptance of any changes or revisions.'
            ),
            (0, _preact.h)(
              'h2',
              null,
              'Responsible service of alcohol. '
            ),
            (0, _preact.h)(
              'p',
              null,
              'We\u2019ve said it before, but we\u2019ll say it again. Under Singaporean law, alcoholic beverages can only be sold or supplied to persons aged 18 years of age or over.'
            ),
            (0, _preact.h)(
              'p',
              null,
              'By using the site or Trouble Brewing\u2019s services, and/or placing an order you are confirming to us that you are at least 18 years of age. When you receive deliveries, recipients may also be asked to provide identification to confirm your age.'
            ),
            (0, _preact.h)(
              'p',
              null,
              'We also encourage the legal and responsible consumption of alcoholic beverages. The beer we make is great \u2013 don\u2019t waste it on getting wasted. '
            ),
            (0, _preact.h)(
              'h2',
              null,
              'Using our services:'
            ),
            (0, _preact.h)(
              'p',
              null,
              'By using Trouble Brewing\u2019s services, you are confirming you\u2019re not going to act like a d*ck \u2013 and you\u2019re not going to encourage conduct that would constitute a criminal offence or give rise to civil liability, or that otherwise violates any local, state, national or international law or regulation.'
            ),
            (0, _preact.h)(
              'p',
              null,
              'Anything you do with Trouble Brewing, including using the website/our services shall be used for lawful purposes only and that you will not use any obscene or offensive language, or do anything that is false, defamatory, abusive, harassing or hateful to anyone else.'
            ),
            (0, _preact.h)(
              'p',
              null,
              'You agree and acknowledge that your failure to follow the rules set forth in this Agreement may subject you to civil and criminal liability.'
            ),
            (0, _preact.h)(
              'h2',
              null,
              'Intellectual Property'
            ),
            (0, _preact.h)(
              'p',
              null,
              'Any logos, brand marks, trademarks or branding you see on this site, or used in our product/services is the property of their respective owner(s). All the Trouble Brewing design elements/logos/copy you see is ours \u2013 so reproduction is prohibited unless otherwise stated.'
            ),
            (0, _preact.h)(
              'p',
              null,
              'Securing relevant usage/imagery rights/licences for any labels/artwork/designs produced by Trouble Brewing will be the sole responsibility of the customer. Trouble Brewing will not be responsible for the acquisition or organisation of any licences or applicable rights for images.'
            ),
            (0, _preact.h)(
              'p',
              null,
              'By using our site/services, you agree and acknowledge that you (customer) have the usage/own/rights to use the imagery supplied you shall be solely liable for any damages resulting from any infringement of copyrights, trademarks, or proprietary rights.'
            ),
            (0, _preact.h)(
              'h2',
              null,
              'Privacy Policy'
            ),
            (0, _preact.h)(
              'p',
              null,
              'To deliver you our services (and your beer) we will need to collect personal information. That\u2019s pretty obvious, but worth stating.'
            ),
            (0, _preact.h)(
              'p',
              null,
              'Trouble Brewing\u2019s Privacy Policy sets out how we collect and use personal information. You can read our Privacy Policy at troublebrewing.com/privacy. By using the service, you consent to our collection, use and disclosure of your personal information in the manner set out in the Privacy Policy.'
            ),
            (0, _preact.h)(
              'h2',
              null,
              'Accuracy of the Site/Social Channels and Linking'
            ),
            (0, _preact.h)(
              'p',
              null,
              'Our site is here for your general information and use only. It is subject to change without notice. Trouble Brewing does not provide any warranty or guarantee as to the accuracy, quality or completeness of the information and materials found on the service for any particular purpose.'
            ),
            (0, _preact.h)(
              'p',
              null,
              'Your use of any information or materials on the service is entirely at your own risk; Trouble Brewing will not be liable. It shall be your own responsibility to ensure that anything we are providing you through our site or services meet your specific needs and requirements.'
            ),
            (0, _preact.h)(
              'p',
              null,
              'Any third party information/opinions placed on our social media channels/site or on the actual beers/products by users, is the view and responsibility of those users and does not represent the views of Trouble Brewing.'
            ),
            (0, _preact.h)(
              'p',
              null,
              'Our social channels/site may also include links to other websites. The links are provided solely for your convenience and do not indicate, expressly or impliedly, any endorsement by Trouble Brewing of the site(s) contents or services. Clicking and going to links to any other service or site from this service is at your sole risk.'
            ),
            (0, _preact.h)(
              'h2',
              null,
              'Limitation of Liability'
            ),
            (0, _preact.h)(
              'p',
              null,
              'Trouble Brewing does not make any representations or warranties of any kind, express or implied, in relation to all or any part of the service, and all warranties and representations are hereby excluded to the extent permitted by law.'
            ),
            (0, _preact.h)(
              'p',
              null,
              'The contents of the site/service do not constitute advice and should not be relied upon in making, or refraining from making, any decision.'
            ),
            (0, _preact.h)(
              'p',
              null,
              'To the extent permitted by law, Trouble Brewing hereby disclaims all liability (however it arises) in connection with any loss and/or damage, arising out of or in connection with any use of, or inability to use, all or any part of our site or service.'
            ),
            (0, _preact.h)(
              'p',
              null,
              'These terms and conditions shall be governed and construed in accordance with the laws of Singapore, and you submit to the non-exclusive jurisdiction of the courts of Singapore.\xA0'
            )
          )
        ),
        (0, _preact.h)(_border2.default, { color: 'black' })
      ),
      (0, _preact.h)(_footer2.default, null)
    );
  };

  return Terms;
}(_preact.Component);

exports.default = Terms;

/***/ }),

/***/ "s2D/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e600a9d594795eefbc74e1bc590647c2.svg";

/***/ }),

/***/ "tKK3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("KM04");

var _border = __webpack_require__("nZ5c");

var _border2 = _interopRequireDefault(_border);

var _footer = __webpack_require__("KlFx");

var _footer2 = _interopRequireDefault(_footer);

var _content = __webpack_require__("2AfE");

var _content2 = _interopRequireDefault(_content);

var _trade = __webpack_require__("o15H");

var _trade2 = _interopRequireDefault(_trade);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Trade = function (_Component) {
  _inherits(Trade, _Component);

  function Trade() {
    _classCallCheck(this, Trade);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Trade.prototype.render = function render() {
    return (0, _preact.h)(
      'div',
      null,
      (0, _preact.h)(
        'div',
        { className: _trade2.default.container },
        (0, _preact.h)(
          _content2.default,
          null,
          (0, _preact.h)(
            'div',
            { className: _trade2.default.text },
            (0, _preact.h)(
              'div',
              { className: 'flex' },
              (0, _preact.h)(
                'a',
                { href: '/' },
                (0, _preact.h)('img', { className: _trade2.default.logo, src: '/assets/logo-red.png', alt: 'Trouble Brewing' })
              ),
              (0, _preact.h)(
                'h1',
                { className: _trade2.default.title },
                'Trade Compliance Policy Statement'
              )
            ),
            (0, _preact.h)(
              'p',
              null,
              'This trade compliance policy reflects Trouble Brewing\u2019s commitment to operate in accordance with our code of ethics and business conducts. It also recognizes that failure to meet trade compliance requirements can have serious consequences for us, including damage to the Company\u2019s reputation, monetary penalties, and suspension/revocation of the company\u2019s trading and importing privileges with a resulting negative impact to our customers. Thus, we are committed to the implementation, maintenance and continuous improvement of a robust trade compliance policy, which integrates compliance activities into our business processes.'
            ),
            (0, _preact.h)(
              'h2',
              null,
              'Import Compliance'
            ),
            (0, _preact.h)(
              'p',
              null,
              'All equipment and inventory imports we facilitate are to be accurately described and applicable under the laws of Singapore.'
            ),
            (0, _preact.h)(
              'p',
              null,
              'All Customs entries shall accurately state all required information, including the importer of record\u2019s name and address, importer number, quantity, value, classification, duty preference eligibility, and country of origin for the imported items.'
            ),
            (0, _preact.h)(
              'h2',
              null,
              'Compliance Responsibility'
            ),
            (0, _preact.h)(
              'p',
              null,
              'All employees are responsible for supporting the principles contained in this policy.'
            )
          )
        ),
        (0, _preact.h)(_border2.default, { color: 'black' })
      ),
      (0, _preact.h)(_footer2.default, null)
    );
  };

  return Trade;
}(_preact.Component);

exports.default = Trade;

/***/ }),

/***/ "tMjC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("KM04");

var _emailValidator = __webpack_require__("avpp");

var _emailValidator2 = _interopRequireDefault(_emailValidator);

var _reactFacebookPixel = __webpack_require__("1yJE");

var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);

var _textBox = __webpack_require__("zN4C");

var _textBox2 = _interopRequireDefault(_textBox);

var _button = __webpack_require__("mvbk");

var _button2 = _interopRequireDefault(_button);

var _inlineMessage = __webpack_require__("3zBa");

var _inlineMessage2 = _interopRequireDefault(_inlineMessage);

var _contactForm = __webpack_require__("R8GG");

var _contactForm2 = _interopRequireDefault(_contactForm);

var _config = __webpack_require__("MmR0");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var API = _config2.default.firebase.cloudFunctionUrl + '/getInTouch';

var ContactForm = function (_Component) {
  _inherits(ContactForm, _Component);

  function ContactForm() {
    var _temp, _this, _ret;

    _classCallCheck(this, ContactForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      errors: [],
      sending: false,
      sent: false,
      name: '',
      phone: '',
      email: '',
      comments: ''
    }, _this.isFormValid = function () {
      var _this$state = _this.state,
          name = _this$state.name,
          email = _this$state.email,
          phone = _this$state.phone;

      if (!name.length || !email.length || !phone.length) {
        return false;
      }

      if (!_emailValidator2.default.validate(email)) {
        return false;
      }

      return true;
    }, _this.getFormErrors = function () {
      var _this$state2 = _this.state,
          name = _this$state2.name,
          email = _this$state2.email,
          phone = _this$state2.phone;

      var errors = [];
      if (!name.length) {
        errors.push('Enter your name so we know who we\'ll be getting in touch with');
      }

      if (!phone.length) {
        errors.push('Enter your phone number so we know who to call');
      }

      if (!_emailValidator2.default.validate(email)) {
        errors.push('Check that the email address is correct (it doesn\'t look valid)');
      }

      ga('send', 'event', 'ContactForm', 'Errors', errors.length);
      return errors;
    }, _this.onTextChange = function (event) {
      var _this$setState;

      _this.setState((_this$setState = {}, _this$setState[event.target.name] = event.target.value, _this$setState));
    }, _this.onContact = function () {
      var errors = _this.getFormErrors();
      if (errors.length) {
        _this.setState({
          errors: errors
        });
        return;
      }

      var _this$state3 = _this.state,
          name = _this$state3.name,
          email = _this$state3.email,
          phone = _this$state3.phone,
          comments = _this$state3.comments;

      ga('send', 'event', 'ContactForm', 'Form', 'FetchSend');
      fetch(API, {
        mode: 'cors',
        headers: {
          'Content-Type': 'text/plain',
          'Access-Control-Allow-Origin': true
        },
        method: 'POST',
        body: JSON.stringify({
          name: name,
          email: email,
          phone: phone,
          comments: comments
        })
      }).then(function (res) {
        console.log(res.status);
      });

      _this.setState({
        sending: true,
        errors: []
      });

      setTimeout(function () {
        ga('send', 'event', 'ContactForm', 'Form', 'Send');
        _reactFacebookPixel2.default.track('Lead', {
          content_name: 'Contact'
        });
        _this.setState({
          sent: true
        });
      }, 1000);
    }, _this.renderErrors = function () {
      var errors = _this.state.errors;


      if (!errors.length) {
        return null;
      }
      return (0, _preact.h)(
        _inlineMessage2.default,
        { type: 'error' },
        (0, _preact.h)(
          'p',
          { className: _contactForm2.default.errorTitle },
          'Uh-oh, looks like there are some issues with your contact details. Can you please:'
        ),
        (0, _preact.h)(
          'ul',
          { className: _contactForm2.default.errorList },
          errors.map(function (e, idx) {
            return (0, _preact.h)(
              'li',
              { key: idx },
              e
            );
          })
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ContactForm.prototype.render = function render(props, _ref) {
    var name = _ref.name,
        phone = _ref.phone,
        email = _ref.email,
        comments = _ref.comments,
        sent = _ref.sent,
        sending = _ref.sending;


    if (sent) {
      return (0, _preact.h)(
        _inlineMessage2.default,
        { type: 'success' },
        'Thanks! Someone will in touch shortly'
      );
    }

    var buttonText = sending ? 'Sending...' : 'Get in touch';

    return (0, _preact.h)(
      'div',
      null,
      this.renderErrors(),
      (0, _preact.h)(_textBox2.default, { name: 'name', onChange: this.onTextChange, label: 'Your name', value: name, className: _contactForm2.default.input }),
      (0, _preact.h)(_textBox2.default, { name: 'phone', onChange: this.onTextChange, label: 'Your phone number', value: phone, className: _contactForm2.default.input }),
      (0, _preact.h)(_textBox2.default, { name: 'email', onChange: this.onTextChange, label: 'Your email address', value: email, className: _contactForm2.default.input }),
      (0, _preact.h)(_textBox2.default, { multiline: true, name: 'comments', onChange: this.onTextChange, label: 'Is there anything else you want to add?', value: comments }),
      (0, _preact.h)(
        _button2.default,
        { disabled: sending || sent, className: _contactForm2.default.button, onClick: this.onContact },
        buttonText
      )
    );
  };

  return ContactForm;
}(_preact.Component);

exports.default = ContactForm;

/***/ }),

/***/ "u4iN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"container__1WiOu","input":"input__3T1M3","disabled":"disabled__1-4Ga","label":"label__20C3a","labelContent":"labelContent__30l0j"};

/***/ }),

/***/ "wRU+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),

/***/ "wVGV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__("UQex");
var invariant = __webpack_require__("wRU+");
var ReactPropTypesSecret = __webpack_require__("Asjh");

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ "xofd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "06e87d404276a11c64de661da86cc0b6.svg";

/***/ }),

/***/ "yNJ0":
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),

/***/ "zN4C":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.propsToRemove = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = __webpack_require__("KM04");

var _classnames = __webpack_require__("9qb7");

var _classnames2 = _interopRequireDefault(_classnames);

var _textBox = __webpack_require__("u4iN");

var _textBox2 = _interopRequireDefault(_textBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propsToRemove = exports.propsToRemove = ['setValidations', 'resetValue', 'hasValue', 'getErrorMessage', 'getErrorMessages', 'isFormDisabled', 'isValid', 'isPristine', 'isFormSubmitted', 'isRequired', 'showRequired', 'showError', 'isValidValue', 'validationError', 'validationErrors', 'onChange', 'containerClassName'];

var TextBox = function (_Component) {
  _inherits(TextBox, _Component);

  function TextBox(props) {
    _classCallCheck(this, TextBox);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.componentWillReceiveProps = function (nextProps) {
      _this.setState({
        hasContent: nextProps.value && nextProps.value.length
      });
    };

    _this.changeHandler = function (event) {
      var onChange = _this.props.onChange;

      _this.setState({
        hasContent: !!event.target.value.length
      });

      if (onChange) {
        onChange(event);
      }
    };

    _this.state = {
      hasContent: !!(props.value && props.value.length || props.defaultValue && props.defaultValue.length)
    };
    return _this;
  }

  TextBox.prototype.render = function render() {
    var _cn;

    var _props = this.props,
        className = _props.className,
        containerClassName = _props.containerClassName,
        label = _props.label,
        disabled = _props.disabled,
        multiline = _props.multiline;

    var inputProps = Object.assign({}, this.props, {
      className: (0, _classnames2.default)('handDrawn', className, _textBox2.default.input, (_cn = {}, _cn[_textBox2.default.inputFilled] = this.state.hasContent, _cn[_textBox2.default.disabled] = disabled, _cn))
    });
    var labelClasses = (0, _classnames2.default)(_textBox2.default.label);
    var containerClasses = (0, _classnames2.default)(_textBox2.default.container, containerClassName);
    var Cmp = multiline ? 'textarea' : 'input';

    // Remove any of our custom props that shouldn't be passed down to <input />
    propsToRemove.forEach(function (key) {
      return delete inputProps[key];
    });

    return (0, _preact.h)(
      'span',
      { className: containerClasses },
      (0, _preact.h)(
        'label',
        { className: labelClasses },
        (0, _preact.h)(
          'span',
          { className: _textBox2.default.labelContent },
          (0, _preact.h)(
            'span',
            null,
            label
          )
        )
      ),
      (0, _preact.h)(Cmp, _extends({}, inputProps, { onInput: this.changeHandler }))
    );
  };

  return TextBox;
}(_preact.Component);

exports.default = TextBox;

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.d534a.js